import React from 'react';
import { Modal, Form, message, Input, Button, Select, DatePicker, Checkbox, Radio, Spin, Tag, Popover, InputNumber } from 'antd';
import TimePicker from 'components/TimePicker';
import dayjs from 'utils/dayjs';
import { Event, EScheduledBy, EScheduleStatusLabel, EScheduleStatusValue, EProvicerCancelReasonLabel, TServerCalendarBlockerEventDetail, ERepeatType, TProviderAppointmentBilling, EPatientCancelReasonLabel, TServerCalendarAppointmentEventDetail, ERescheduledAction } from 'types/calendar';
import { FormInterface } from './types';
import { calendarCreateOrUpdateAppointment, calendarCreateOrUpdateBlocker, calendarUpdateAppointmentStatus, TUpdateAppointmentStatus, deleteCalendarBlockerEvent, deleteCalendarAppointmentEvent, sendPatientPortalInvitation, getProviderTimeSlotByLength } from 'api/google';
import s from './s.module.less';
import { getTimeStr } from 'utils/calendar';
import useTimezone from 'hooks/useTimezone';
import { DEFAULT_CALENDAR_COLOR } from 'constants/common';
import { EContactTypeV2, EContactTypeV2Label, EOnBoardingStatus, EServiceType, KlarityService, Prospect, TAppointment } from 'types/common';
import { TimeItemType } from 'types/appointmentSetting';
import USPhoneInput from 'components/form/USPhoneInput';
import TimeSelect from 'components/form/TimeSelect';
import { useRequest } from 'ahooks';
import { getProspectList } from 'api/prospect';
import TextArea from 'antd/es/input/TextArea';
import AddAndUpdateProspects from 'components/AddAndUpdateProspects';
import useProviderKlarityServiceList from 'hooks/useProviderKlarityServiceList';
import useCalendarAppointmentEventDetail from 'hooks/useCalendarAppointmentEventDetail';
import useCalendarBlockerEventDetail from 'hooks/useCalendarBlockerEventDetail';
import {
    useNavigate,
} from 'react-router-dom';
import { PATH } from 'constants/path';
import { RRule } from 'rrule';
import { useCalendarCustomize } from 'hooks/useCalendarCustomize';
import useGetSpecialtiesAndConditions from 'hooks/useGetSpecialtiesAndConditions';
import commonS from 'styles/common.module.less';
import ProviderStore from 'store/Provider';
import { getProviderNameDisplay } from 'utils/provider';
import { useBillingPolicy } from 'hooks/paymentSetup/useBillingPolicy';
import { BillingPolicyType } from 'types/paymentSetup';
import { isLocalhost } from 'utils/common';
import { getUserId } from 'utils/localstore';
import { has } from 'lodash';

type Props = {
    onCancel: () => void
    event?: Event //for edit fun
    onSuccess?: () => void
    defaultStart?: dayjs.Dayjs,
    defaultEnd?: dayjs.Dayjs,
    timezone?: string,
    isPopLayer?: boolean,
    allSpecialityData?: KlarityService[],
};

enum EScheduleUnit {
    DAYS = 'Days',
    WEEKS = 'Weeks',
    MONTHS = 'Months',
}

type TChangeToPatientNoShowOrLateCancelRef = {
    status: EScheduleStatusValue.PATIENT_NO_SHOW | EScheduleStatusValue.PATIENT_LATE_CANCELED | undefined,
    chargeFee: boolean,
};

const AddAndEditCalendarEvent = (props: Props) => {
    const { onCancel, event, onSuccess, defaultStart, defaultEnd, timezone, isPopLayer, allSpecialityData } = props;
    const [, myTimezone] = useTimezone();
    const [form] = Form.useForm<FormInterface>();
    const [submiting, setSubmiting] = React.useState(false);
    const [rescheduling, setRescheduling] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);
    const [, forceUpdate] = React.useState({});
    const [serviceData, serviceDataLoading, refetchServiceData] = useProviderKlarityServiceList(false, getUserId());

    const [mode, setMode] = React.useState<1 | 2>(1);
    const [timeVal, setTimeVal] = React.useState<TimeItemType>();

    const [currentAppType, setCurrentAppType] = React.useState<EContactTypeV2>(EContactTypeV2.VIDEO);
    const [currentServiceType, setCurrentServiceType] = React.useState<string>();
    const [currentSpecialty, setCurrentSpecialty] = React.useState<string>();
    const [allSpecialtiesOptions] = useGetSpecialtiesAndConditions({ isOps: false });

    const [blockTimeTitle, setBlockTimeTitle] = React.useState('Block time');
    const [allDay, setAllDay] = React.useState(false);
    const [declineAll, setDeclineAll] = React.useState(false);
    const [blockDayStart, setBlockDayStart] = React.useState<dayjs.Dayjs>();
    const [blockDayEnd, setBlockDayEnd] = React.useState<dayjs.Dayjs>();

    const [appointmentDate, setAppointmentDate] = React.useState<dayjs.Dayjs | undefined>(dayjs());
    const [duration, setDuration] = React.useState<number>();
    const [meetingLink, setMeetingLink] = React.useState<string>('');
    const [location, setLocation] = React.useState<string>('');
    const [patientPhone, setPatientPhone] = React.useState<string>('');
    const [reason, setReason] = React.useState<string>('');
    const [serviceItems, loadingServiceItems] = useCalendarCustomize();

    const [isViewOnly, setIsViewOnly] = React.useState(true);
    const [scheduleStatus, setScheduleStatus] = React.useState<EScheduleStatusValue | undefined>(EScheduleStatusValue.SCHEDULED);
    const [updatingScheduleType, setUpdatingScheduleType] = React.useState(false);

    const { data, loading, run } = useRequest(getProspectList);
    const [allClient, setAllClient] = React.useState<Prospect[]>([]);
    const [clientId, setClientId] = React.useState<number>();
    const [pendingClientId, setPendingClientId] = React.useState<number>(); // after add

    const [showConfirmChangeNoteModal, setShowConfirmChangeNoteModal] = React.useState(false);//v1

    const [showConfirmRemoveAppointmentModal, setShowConfirmRemoveAppointmentModal] = React.useState(false);
    const [showConfirmRemoveBlockerModal, setShowConfirmRemoveBlockerModal] = React.useState(false);

    const [showConfirmProviderCancelModal, setShowConfirmProviderCancelModal] = React.useState(false);
    const [showConfirmPatientCancelModal, setShowConfirmPatientCancelModal] = React.useState(false);

    const [showConfirmPatientNoShowOrLateCancelNoProtectModal, setShowConfirmPatientNoShowOrLateCancelNoProtectModal] = React.useState(false);
    const [showConfirmPatientNoShowOrLateCancelProtectModal, setShowConfirmPatientNoShowOrLateCancelProtectModal] = React.useState(false);

    const [showConfirmShowModal, setShowConfirmShowModal] = React.useState(false);
    const [selectScheduleItemIndex, setSelectScheduleItemIndex] = React.useState<number>(2);

    const [scheduleReminderValue, setScheduleReminderValue] = React.useState<number | undefined>(14);
    const [scheduleReminderUnit, setScheduleReminderUnit] = React.useState<string>(EScheduleUnit.DAYS);
    const [scheduleReminderTime, setScheduleReminderTime] = React.useState<number>();
    const [scheduleReminderText, setScheduleReminderText] = React.useState<string>();
    const scheduleReminderAreaRef = React.useRef<any>(null);

    const [scheduleSmartFollowUpValue, setScheduleSmartFollowUpValue] = React.useState<number | undefined>(14);
    const [scheduleSmartFollowUpUnit, setScheduleSmartFollowUpUnit] = React.useState<string>(EScheduleUnit.DAYS);
    const [scheduleSmartFollowUpTime, setScheduleSmartFollowUpTime] = React.useState<number>();
    const [scheduleSmartFollowUpText, setScheduleSmartFollowUpText] = React.useState<string>();

    const [defaultNextFollowUpTime, setDefaultNextFollowUpTime] = React.useState<number>();
    const [defaultRescheduleTime, setDefaultRescheduleTime] = React.useState<number>();

    const [emailSign, setEmailSign] = React.useState<string>();
    const [customizeText, setCustomizeText] = React.useState<string>();

    const changeToShowActionRef = React.useRef<'skip' | 'confirm' | undefined>();
    const changeToPatientNoShowOrLateCancelRef = React.useRef<TChangeToPatientNoShowOrLateCancelRef>();
    const [showCannotChargeIn24HourModal, setShowCannotChargeIn24HourModal] = React.useState(false);

    const [showChargeFeeMessage, setShowChargeFeeMessage] = React.useState(false);
    const [showWaiveFeeMessage, setShowWaiveFeeMessage] = React.useState(false);

    const [cancelReason, setCancelReason] = React.useState<string>();
    const [cancelReasonSub, setCancelReasonSub] = React.useState<string>();
    const [cancelReasonOther, setCancelReasonOther] = React.useState<string>();

    const [showReschedulePickTimeModal, setShowReschedulePickTimeModal] = React.useState(false);
    const [showRescheduleConfirmModal, setShowRescheduleConfirmModal] = React.useState(false);
    const [rescheduleTime, setRescheduleTime] = React.useState<number>();

    const [cancelReasonForLateCancel, setCancelReasonForLateCancel] = React.useState<string>();

    const [changeCustomizeText, setChangeCustomizeText] = React.useState<string>();

    const [showAddClient, setShowAddClient] = React.useState(false);

    const listData: Prospect[] = data?.data?.data || [];

    const [providerServiceList] = useProviderKlarityServiceList();

    const [appointmentEventDetail, loadingAppointmentEventDetail, fetchDetail] = useCalendarAppointmentEventDetail(event?.type === 'appointment' ? event : undefined);
    const [blockEventDetail, loadingBlockEventDetail] = useCalendarBlockerEventDetail(event?.type === 'blocker' ? event : undefined);

    const isSampleApp = (appointmentEventDetail && appointmentEventDetail.isSample) || (blockEventDetail && blockEventDetail.isSample);
    const clientOption = isSampleApp ? listData : listData?.filter((item) => !item.isSample);

    const [repeatType, setRepeatType] = React.useState<ERepeatType>(ERepeatType.DOES_NOT_REPEAT);
    const [repeatText, setRepeatText] = React.useState<string>('');
    const [hasClickSendPatientPortalInvitation, setHasClickSendPatientPortalInvitation] = React.useState(false);
    const [sendingInvitation, setSendingInvitation] = React.useState(false);

    const textAreaRef = React.useRef<any>(null);
    const [getUser] = ProviderStore.useStore();

    const [showTimeSelectModal, setShowTimeSelectModal] = React.useState<boolean>(false);

    const [timeZone, setTimeZone] = React.useState<string>('');
    const [timeSlotList, setTimeSlotList] = React.useState<number[]>([]);
    const [loadingTimeSlot, setLoadingTimeSlot] = React.useState<boolean>(false);

    let targetSpeciality: KlarityService | undefined;

    if (appointmentEventDetail && appointmentEventDetail.serviceSpecialty) {
        targetSpeciality = allSpecialityData?.find((item) => item.specialtyName === appointmentEventDetail.serviceSpecialty);
    }
    const [billingPolicy, billingPolicyLoading] = useBillingPolicy();
    const navigate = useNavigate();

    const isEdit = !!event;
    const isGoogleEvent = event?.type === 'google';
    const isBlockEvent = event?.type === 'blocker';
    const showAddApponitmentForm = !isEdit && mode === 1;
    const showEditAppointmentForm = isEdit && !isBlockEvent && !isViewOnly;
    const showEditAppointmentView = isEdit && !isBlockEvent && isViewOnly;

    const showAddBlockTimeForm = !isEdit && mode === 2;
    const showEditBlockTimeForm = isEdit && isBlockEvent && !isViewOnly;
    const showEditBlockTimeView = isEdit && isBlockEvent && isViewOnly;
    const confirmChangeMes = `
Hi, 
I’ve updated the location for your appointment on [Date, Time]. 
The new location is: In-person visit: [New location].
    
Let me know if you have any questions.
Best,
[Provider name], [Credential]
`;

    const removeMes = `
Sorry, but due to unforeseen circumstances, we need to reschedule your appointment. Please reach out to me so we can find a new time that works for you.
   `;

    const isLoading = loadingServiceItems;

    const isProviderScheduleEvent = appointmentEventDetail?.scheduledBy === EScheduledBy.PROVIDER_SCHEDULED;
    //const isProviderScheduleEvent = false;
    const showEditButton = appointmentEventDetail && (appointmentEventDetail?.appointmentStatus === EScheduleStatusValue.SCHEDULED || !appointmentEventDetail?.appointmentStatus) && !isGoogleEvent;
    //const showEditButton = true;
    const isCanceled = appointmentEventDetail && appointmentEventDetail.appointmentStatus && ([EScheduleStatusValue.PATIENT_CANCELED, EScheduleStatusValue.PATIENT_LATE_CANCELED, EScheduleStatusValue.PATIENT_NO_SHOW, EScheduleStatusValue.PROVIDER_CANCELED].includes(appointmentEventDetail.appointmentStatus));
    let tagText = isProviderScheduleEvent ? 'Self-created appointment' : 'Appointment from Klarity';
    if (isGoogleEvent) {
        tagText = 'Google event';
    }
    const canChangeStatus = appointmentEventDetail && (!appointmentEventDetail.appointmentStatus || appointmentEventDetail.appointmentStatus === EScheduleStatusValue.SCHEDULED);

    //const canChangeStatus = true;

    let canCancelAppointment = false;
    if (cancelReason) {
        if (cancelReason === EProvicerCancelReasonLabel.OTHER_REASONS || cancelReason === EPatientCancelReasonLabel.OTHER_REASONS) {
            if (cancelReasonOther || cancelReasonSub) {
                canCancelAppointment = true;
            }
        } else {
            canCancelAppointment = true;
        }
    }

    const specialtiesOptions: string[] = [];
    providerServiceList?.forEach((item) => {
        if (item.serviceSpecialtyName && !specialtiesOptions.includes(item.serviceSpecialtyName)) {
            specialtiesOptions.push(item.serviceSpecialtyName);
        }
    });

    const targetClient = listData.find((item) => `${item.id}` === `${clientId}`);
    const eventClient = listData.find((item) => `${item.id}` === `${appointmentEventDetail?.clientId}`);

    const isProtect = eventClient?.onBoardingStatus === EOnBoardingStatus.COMPLETE;
    let isCharge = isProtect;
    let chargetBilling: TProviderAppointmentBilling | undefined;
    if (appointmentEventDetail?.appointmentStatus === EScheduleStatusValue.PATIENT_LATE_CANCELED || appointmentEventDetail?.appointmentStatus === EScheduleStatusValue.PATIENT_NO_SHOW) {
        if (appointmentEventDetail.providerAppointmentCancelInfo) {
            isCharge = !!(appointmentEventDetail.providerAppointmentCancelInfo.confirmCharge);
            if (isCharge) {
                chargetBilling = appointmentEventDetail?.providerAppointmentBillings?.find((item) => {
                    if (appointmentEventDetail?.appointmentStatus === EScheduleStatusValue.PATIENT_LATE_CANCELED) {
                        return item.chargeType === BillingPolicyType.LATE_CANCELLATION || item.chargeType === EScheduleStatusValue.PATIENT_LATE_CANCELED;
                    }
                    if (appointmentEventDetail?.appointmentStatus === EScheduleStatusValue.PATIENT_NO_SHOW) {
                        return item.chargeType === BillingPolicyType.NO_SHOW || item.chargeType === EScheduleStatusValue.PATIENT_NO_SHOW;
                    }
                    return false;
                });
            }
        }
    }
    let chargetText = 'Not charged';
    if (isCharge) {
        if (chargetBilling) {
            if (chargetBilling.billingStatus === 'SUCCEEDED') {
                chargetText = `$${(chargetBilling?.amountCents / 100).toFixed(2)} charged`;
            } else if (chargetBilling.billingStatus === 'PROCESSING') {
                chargetText = 'Charge-in-process';
            } else if (chargetBilling.billingStatus === 'NOT_READY') {
                chargetText = 'Not charged yet (You need to set-up billing first)';
            } else {
                //failed, not expect
                chargetText = `Not charged yet (${chargetBilling.billingStatus})`;
            }
        } else {
            chargetText = 'Not charged (not biling info)';
        }
        if (appointmentEventDetail && appointmentEventDetail.isSample) {
            chargetText = '$50 charged';
        }
    }
    const isCurrentClientProtect = targetClient?.creditCardOnFile;
    const canSendPatientPortalLink = !eventClient?.onBoardingStatus || eventClient?.onBoardingStatus === EOnBoardingStatus.NOT_SENT;

    const targetService = serviceItems?.find((service) => {
        return service.serviceType === currentServiceType;
    });

    const weekday = blockDayStart?.format('dddd') || null;
    const dayOfMonth = blockDayStart?.date() || null;
    let suffix = 'th';
    if (dayOfMonth === 1 || dayOfMonth === 21 || dayOfMonth === 31) {
        suffix = 'st';
    } else if (dayOfMonth === 2 || dayOfMonth === 22) {
        suffix = 'nd';
    } else if (dayOfMonth === 3 || dayOfMonth === 23) {
        suffix = 'rd';
    }

    let chargeFee = 0;
    let chargeIn24Hour = false;
    if (appointmentEventDetail && appointmentEventDetail.createdAt) {
        chargeIn24Hour = Math.abs(dayjs(appointmentEventDetail.createdAt).diff(dayjs(), 'hour')) <= 24;
    }
    const statusLabel = changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_NO_SHOW ? 'No-show' : 'Late cancellation';
    let chargerFeeTitle = `Charge patient ${statusLabel?.toLowerCase()} fee`;
    if (showChargeFeeMessage) {
        chargerFeeTitle = `${statusLabel} fee applied`;
    } else if (showWaiveFeeMessage) {
        chargerFeeTitle = `${statusLabel} fee waived`;
    }
    if (changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_NO_SHOW) {
        const target = billingPolicy?.find((item) => {
            return item.type === BillingPolicyType.NO_SHOW || item.type.toLowerCase() === EScheduleStatusValue.PATIENT_NO_SHOW;
        });
        if (target?.enable) {
            chargeFee = target?.fee || 0;
        }
    }
    if (changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_LATE_CANCELED) {
        const target = billingPolicy?.find((item) => {
            return item.type === BillingPolicyType.LATE_CANCELLATION || item.type.toLowerCase() === EScheduleStatusValue.PATIENT_LATE_CANCELED;
        });
        if (target?.enable) {
            chargeFee = target?.fee || 0;
        }
    }

    const getContactTypeLabel = (type?: string): string => {
        if (type === EContactTypeV2.VIDEO) {
            return EContactTypeV2Label.VIDEO;
        }
        if (type === EContactTypeV2.IN_PERSON) {
            return EContactTypeV2Label.IN_PERSON;
        }
        if (type === EContactTypeV2.TELEPHONE) {
            return EContactTypeV2Label.TELEPHONE;
        }
        return type || '';
    };

    let optionsRepeat = [
        {
            label: 'Does not repeat',
            value: ERepeatType.DOES_NOT_REPEAT,
        },
        {
            label: 'Daily',
            value: ERepeatType.DAILY,
        },
        {
            label: 'Every weekday (Monday to Friday)',
            value: ERepeatType.EVERY_WEEKDAY,
        },
    ];

    if (blockDayStart) {
        optionsRepeat = [
            {
                label: 'Does not repeat',
                value: ERepeatType.DOES_NOT_REPEAT,
            },
            {
                label: 'Daily',
                value: ERepeatType.DAILY,
            },
            {
                label: `Weekly on ${weekday}`, //Weekly on Friday
                value: ERepeatType.WEEKLY_ON_WEEKDAY,
            },
            {
                label: `Monthly on the first ${weekday}`, //Monthly on the first Friday
                value: ERepeatType.MONTHLY_ON_FIRST_DAY,
            },
            {
                label: `Monthly on the ${dayOfMonth}${suffix}`, //Monthly on the first Friday
                value: ERepeatType.MONTHLY_ON_DATE,
            },

            {
                label: 'Every weekday (Monday to Friday)',
                value: ERepeatType.EVERY_WEEKDAY,
            },
        ];
    }

    React.useEffect(() => {
        if (!event && serviceItems && serviceItems.length > 0) {
            setCurrentServiceType(serviceItems[0].serviceType);
        }
    }, [serviceItems, event]);

    React.useEffect(() => {
        //setPendingClientId(106387);
    }, []);

    React.useEffect(() => {
        if (data && pendingClientId) {
            const listData: Prospect[] = data?.data?.data || [];
            setAllClient(listData);
            const client = listData.find((item) => `${item.id}` === `${pendingClientId}`);
            if (client) {
                setClientId(pendingClientId);
                setPendingClientId(undefined);
            }
        }
    }, [data, pendingClientId]);

    const handleTimeValChange = (val?: TimeItemType) => {
        setTimeVal(val);
        updateDurationWithTimeVal(val);
    };

    const optionsRelationship = [
        {
            label: 'Child',
            value: 'child',
        },
        {
            label: 'Parent',
            value: 'parent',
        },
        {
            label: 'Spouse or Partner',
            value: 'spouse-or-partner',
        },
        {
            label: 'Sibling',
            value: 'sibling',
        },
        {
            label: 'Friend',
            value: 'friend',
        },
        {
            label: 'My existing patient',
            value: 'my-existing-patient',
        },
        {
            label: 'Other',
            value: 'other',
        },
    ];

    const optionType = [
        {
            label: EContactTypeV2Label.VIDEO,
            value: EContactTypeV2.VIDEO,
        },
        {
            label: EContactTypeV2Label.IN_PERSON,
            value: EContactTypeV2.IN_PERSON,
        },
        {
            label: EContactTypeV2Label.TELEPHONE,
            value: EContactTypeV2.TELEPHONE,
        },
    ];

    const contactTypeText = optionType?.find((item) => item.value === currentAppType)?.label || currentAppType;
    // const optionServiceType = [
    //     {
    //         label: EServiceTypeLabel.INIT,
    //         value: EServiceType.INIT,
    //     },
    //     {
    //         label: EServiceTypeLabel.CONSULTATION,
    //         value: EServiceType.CONSULTATION,
    //     },
    //     {
    //         label: EServiceTypeLabel.ESTABLISHED_PATIENT_VISIT,
    //         value: EServiceType.ESTABLISHED_PATIENT_VISIT,
    //     },
    //     {
    //         label: EServiceTypeLabel.PRESCRIPTION_SERVICE,
    //         value: EServiceType.PRESCRIPTION_SERVICE,
    //     },
    //     {
    //         label: EServiceTypeLabel.OTHER_PATIENT_SUPPORT,
    //         value: EServiceType.OTHER_PATIENT_SUPPORT,
    //     },
    //     {
    //         label: EServiceTypeLabel.MEDICATIONS,
    //         value: EServiceType.MEDICATIONS,
    //     },
    // ];

    const optionServiceType = serviceItems?.map((item) => {
        return {
            label: item.displayName,
            value: item.serviceType,
        };
    });

    const optionSchedule = [
        {
            label: EScheduleStatusLabel.SCHEDULED,
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 10L9.16667 11.6667L12.5 8.33333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="#059669" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            value: EScheduleStatusValue.SCHEDULED,
            toolTips: 'An upcoming appointment that has been confirmed and not cancelled.',
        },
        {
            label: EScheduleStatusLabel.SHOWED,
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 10L9.16667 11.6667L12.5 8.33333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="#059669" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            value: EScheduleStatusValue.SHOWED,
            toolTips: 'Patient attended the scheduled appointment.',
        },
        {
            label: EScheduleStatusLabel.PATIENT_NO_SHOW,
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M12.5 10H7.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="#9CA3AF" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            value: EScheduleStatusValue.PATIENT_NO_SHOW,
            toolTips: 'Patient failed to attend the scheduled appointment without prior notice.',
        },
        {
            label: EScheduleStatusLabel.PATIENT_LATE_CANCELED,
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M8.33333 11.6667L10 10M10 10L11.6667 8.33333M10 10L8.33333 8.33333M10 10L11.6667 11.6667M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="#DC2626" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            value: EScheduleStatusValue.PATIENT_LATE_CANCELED,
            toolTips: 'Patient cancelled the appointment within the timeframe allowed by your late-cancellation billing policy',
        },
        {
            label: EScheduleStatusLabel.PATIENT_CANCELED,
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M8.33333 11.6667L10 10M10 10L11.6667 8.33333M10 10L8.33333 8.33333M10 10L11.6667 11.6667M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="#DC2626" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            value: EScheduleStatusValue.PATIENT_CANCELED,
            toolTips: 'Patient cancelled the appointment after the timeframe allowed by your late-cancellation billing policy',
        },
        {
            label: EScheduleStatusLabel.PROVIDER_CANCELED,
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M8.33333 11.6667L10 10M10 10L11.6667 8.33333M10 10L8.33333 8.33333M10 10L11.6667 11.6667M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="#DC2626" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            value: EScheduleStatusValue.PROVIDER_CANCELED,
            toolTips: 'The healthcare provider cancelled the appointment.',
        },
    ];

    const optionProviderCancelReason = [
        {
            label: EProvicerCancelReasonLabel.SCHEDULE_CONFLICTS,
            value: EProvicerCancelReasonLabel.SCHEDULE_CONFLICTS,
        },
        {
            label: EProvicerCancelReasonLabel.MISMATCH_WITH_SCOPE,
            value: EProvicerCancelReasonLabel.MISMATCH_WITH_SCOPE,
        },
        {
            label: EProvicerCancelReasonLabel.INSURANCE_MISMATCH,
            value: EProvicerCancelReasonLabel.INSURANCE_MISMATCH,
        },
        {
            label: EProvicerCancelReasonLabel.OUTSTANDING_PAYMENTS,
            value: EProvicerCancelReasonLabel.OUTSTANDING_PAYMENTS,
        },
        {
            label: EProvicerCancelReasonLabel.INCOMPLETE_PATIENT_INFORMATION,
            value: EProvicerCancelReasonLabel.INCOMPLETE_PATIENT_INFORMATION,
        },
        {
            label: <div>{EProvicerCancelReasonLabel.OTHER_REASONS} <span style={{ color: '#6B7280' }}> (need to input)</span></div>,
            value: EProvicerCancelReasonLabel.OTHER_REASONS,
        },
    ];

    const optionPatientCancelReason = [
        {
            label: EPatientCancelReasonLabel.PATIENT_HAS_SCHEDULE_CONFLICTS,
            value: EPatientCancelReasonLabel.PATIENT_HAS_SCHEDULE_CONFLICTS,
        },
        {
            label: EPatientCancelReasonLabel.PATIENT_DOES_NOT_HAVE_A_CREDIT_CARD_ON_FILE,
            value: EPatientCancelReasonLabel.PATIENT_DOES_NOT_HAVE_A_CREDIT_CARD_ON_FILE,
        },
        {
            label: EPatientCancelReasonLabel.PATIENT_IS_IRRESPONSIVE,
            value: EPatientCancelReasonLabel.PATIENT_IS_IRRESPONSIVE,
        },
        {
            label: EPatientCancelReasonLabel.PATIENT_WANTS_TO_FIND_ANOTHER,
            value: EPatientCancelReasonLabel.PATIENT_WANTS_TO_FIND_ANOTHER,
        },
        {
            label: EPatientCancelReasonLabel.PATIENT_WANTS_AN_EARLIER_APPOINTMENT,
            value: EPatientCancelReasonLabel.PATIENT_WANTS_AN_EARLIER_APPOINTMENT,
        },
        {
            label: EPatientCancelReasonLabel.PATIENT_DOES_NOT_HAVE_THE_INSURANCE_THAT_I_ACCEPT,
            value: EPatientCancelReasonLabel.PATIENT_DOES_NOT_HAVE_THE_INSURANCE_THAT_I_ACCEPT,
        },
        {
            label: <div>{EProvicerCancelReasonLabel.OTHER_REASONS} <span style={{ color: '#6B7280' }}> (need to input)</span></div>,
            value: EPatientCancelReasonLabel.OTHER_REASONS,
        },
    ];

    //telehealth， personAddress
    // const selectService = services?.find((service) => {
    //     return service.id === targetServiceId;
    // });

    React.useEffect(() => {
        if (defaultStart && defaultEnd) {
            setTimeVal({
                fromHour: defaultStart.hour(),
                fromMinute: defaultStart.minute(),
                toHour: defaultEnd.hour(),
                toMinute: defaultEnd.minute(),
            });
            setDuration(defaultEnd.diff(defaultStart, 'minute'));
        }
        if (defaultStart) {
            setAppointmentDate(defaultStart);
            setBlockDayStart(defaultStart);
        }
    }, [defaultStart, defaultEnd]);

    const handleOpenServiceSetting = () => {
        navigate(`/${PATH.SERVICE_SETTING}`);
    };

    const handleAddOrEditAppointment = async (isEdit?: boolean) => {
        if (!clientId) {
            message.error('Please select client');
            return;
        }
        if (!timeVal) {
            message.error('Please select time');
            return;
        }
        if (!appointmentDate) {
            message.error('Please select date');
            return;
        }
        if (!duration) {
            message.error('Please input duration');
            return;
        }
        if (patientPhone && patientPhone.length !== 10) {
            message.error('Please input valid phone number');
            return;
        }

        if (currentAppType === EContactTypeV2.VIDEO && !meetingLink) {
            message.error('Please input meeting link');
            return;
        }
        if (currentAppType === EContactTypeV2.IN_PERSON && !location) {
            message.error('Please input location');
            return;
        }
        if (currentAppType === EContactTypeV2.TELEPHONE && !patientPhone) {
            message.error('Please input phone number');
            return;
        }

        let startDayjs: dayjs.Dayjs | undefined;
        let endDayjs: dayjs.Dayjs | undefined;

        if (timezone) {
            const currentDate = appointmentDate.date();
            const currentMonth = appointmentDate.month();
            const currentYear = appointmentDate.year();
            //some times day change after change timezone
            startDayjs = appointmentDate.tz(timezone).year(currentYear).month(currentMonth).date(currentDate)
                .hour(timeVal.fromHour!)
                .minute(timeVal.fromMinute!)
                .second(0)
                .utc();
            endDayjs = appointmentDate.tz(timezone).year(currentYear).month(currentMonth).date(currentDate)
                .hour(timeVal.toHour!)
                .minute(timeVal.toMinute!)
                .second(0)
                .utc();
        } else {
            startDayjs = appointmentDate.hour(timeVal.fromHour!).minute(timeVal.fromMinute!).second(0).utc();
            endDayjs = appointmentDate.hour(timeVal.toHour!).minute(timeVal.toMinute!).second(0).utc();
        }

        const startTime = startDayjs.format('YYYY-MM-DDTHH:mm:ss[Z]');
        const endTime = endDayjs.format('YYYY-MM-DDTHH:mm:ss[Z]');
        let data: TServerCalendarAppointmentEventDetail | undefined;
        let appointmentName = currentServiceType || '';
        if (currentSpecialty && currentServiceType) {
            appointmentName = `${currentSpecialty}: ${currentServiceType}`;
        } else if (currentServiceType) {
            appointmentName = currentServiceType;
        } else if (currentSpecialty) {
            appointmentName = currentSpecialty;
        }
        if (targetClient) {
            const isEmpty = appointmentName === '';
            if (isEmpty) {
                appointmentName = `${targetClient.firstName} ${targetClient.lastName}`;
            } else {
                appointmentName = `${targetClient.firstName} ${targetClient.lastName} - ${appointmentName}`;
            }
        }

        let _meetingLink = meetingLink;
        if (_meetingLink && !_meetingLink.startsWith('https://') && !_meetingLink.startsWith('http://')) {
            _meetingLink = `https://${meetingLink}`;
        }

        if (!isEdit) {
            //add
            data = {
                appointmentName,
                clientId: clientId!,
                startAt: startTime,
                endAt: endTime,
                duration,
                serviceType: currentServiceType || '',
                contactType: currentAppType,
                serviceSpecialty: currentSpecialty,
                externalVideoLink: _meetingLink || '',
                location: location || '',
                notes: '',
                reason: '',
                calendarColor: targetService?.color || DEFAULT_CALENDAR_COLOR,
                scheduledBy: EScheduledBy.PROVIDER_SCHEDULED,
                appointmentStatus: scheduleStatus,
                telephone: patientPhone || '',
            };
        } else {
            //edit
            data = {
                ...appointmentEventDetail!,
                appointmentName,
                clientId: clientId!,
                startAt: startTime,
                endAt: endTime,
                duration,
                serviceType: currentServiceType || '',
                contactType: currentAppType,
                serviceSpecialty: currentSpecialty,
                notes: '',
                reason: reason || '',
                scheduledBy: appointmentEventDetail?.scheduledBy || EScheduledBy.PROVIDER_SCHEDULED,
                calendarColor: targetService?.color || appointmentEventDetail?.calendarColor || DEFAULT_CALENDAR_COLOR,
                appointmentStatus: scheduleStatus,
                messageToPatient: changeCustomizeText || '',
                externalVideoLink: _meetingLink || '',
                location: location || '',
                telephone: patientPhone || '',
            };
            if (appointmentEventDetail?.isSample) {
                data.appointmentName = `[Sample] ${appointmentName}`;
            }
            if (currentAppType === EContactTypeV2.VIDEO) {
                data.location = '';
                data.telephone = '';
            }
            if (currentAppType === EContactTypeV2.TELEPHONE) {
                data.location = '';
                data.externalVideoLink = '';
            }
            if (currentAppType === EContactTypeV2.IN_PERSON) {
                data.externalVideoLink = '';
                data.telephone = '';
            }
        }
        setSubmiting(true);
        const result = await calendarCreateOrUpdateAppointment(data);
        setSubmiting(false);
        if (!result.error) {
            if (!isEdit) {
                message.success('Create appointment success!');
            } else {
                message.success('Update appointment info success!');
            }
            onSuccess?.();
        }
    };

    const handleScheduleTypeChange = async (old?: EScheduleStatusValue, newStr?: EScheduleStatusValue, needConfirm?: boolean, successText?: string) => {
        if (newStr === EScheduleStatusValue.PATIENT_NO_SHOW && needConfirm) {
            const target = billingPolicy?.find((item) => {
                return item.type === BillingPolicyType.NO_SHOW || item.type.toLowerCase() === EScheduleStatusValue.PATIENT_NO_SHOW;
            });
            changeToPatientNoShowOrLateCancelRef.current = {
                status: EScheduleStatusValue.PATIENT_NO_SHOW,
                chargeFee: false,
            };
            if (target?.enable) {
                if (isProtect) {
                    setShowConfirmPatientNoShowOrLateCancelProtectModal(true);
                } else {
                    setShowConfirmPatientNoShowOrLateCancelNoProtectModal(true);
                }
                return;
            }
        }
        if (newStr === EScheduleStatusValue.PATIENT_LATE_CANCELED && needConfirm) {
            const target = billingPolicy?.find((item) => {
                return item.type === BillingPolicyType.LATE_CANCELLATION || item.type.toLowerCase() === EScheduleStatusValue.PATIENT_LATE_CANCELED;
            });
            changeToPatientNoShowOrLateCancelRef.current = {
                status: EScheduleStatusValue.PATIENT_LATE_CANCELED,
                chargeFee: false,
            };
            if (target?.enable) {
                if (isProtect) {
                    setShowConfirmPatientNoShowOrLateCancelProtectModal(true);
                } else {
                    setShowConfirmPatientNoShowOrLateCancelNoProtectModal(true);
                }
                return;
            }
        }

        if (newStr === EScheduleStatusValue.PATIENT_CANCELED && needConfirm) {
            setShowConfirmPatientCancelModal(true);
            return;
        }

        if (newStr === EScheduleStatusValue.SHOWED && needConfirm) {
            setShowConfirmShowModal(true);
            return;
        }

        if (!appointmentDate) {
            message.error('Please select date');
            return;
        }
        if (!timeVal) {
            message.error('Please select time');
            return;
        }

        setScheduleStatus(newStr);

        setUpdatingScheduleType(true);

        const reqData: TUpdateAppointmentStatus = {
            appointmentId: appointmentEventDetail?.id!,
            status: newStr || EScheduleStatusValue.SCHEDULED,
            confirmCharge: !!isProtect,
            emailSignature: emailSign || getProviderNameDisplay(getUser('data') as any) + (getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''),
        };
        if (newStr === EScheduleStatusValue.PROVIDER_CANCELED || newStr === EScheduleStatusValue.PATIENT_CANCELED) {
            reqData.cancelReason = cancelReason;
            reqData.otherReason = cancelReasonSub || '';
            reqData.manualReason = cancelReasonOther || '';
            reqData.messageToPatient = customizeText || '';
            reqData.confirmCharge = false;
        }
        if (newStr === EScheduleStatusValue.PATIENT_LATE_CANCELED) {
            reqData.manualReason = cancelReasonForLateCancel;
        }
        if (newStr === EScheduleStatusValue.PATIENT_LATE_CANCELED || newStr === EScheduleStatusValue.PATIENT_NO_SHOW) {
            reqData.confirmCharge = changeToPatientNoShowOrLateCancelRef.current?.chargeFee || false;
            reqData.messageToPatient = customizeText || '';
        }
        if (newStr === EScheduleStatusValue.SHOWED) {
            reqData.confirmCharge = false;
            if (changeToShowActionRef.current === 'confirm') {
                let startAt = '';
                let endAt = '';
                let messageToPatient = '';
                if (selectScheduleItemIndex === 1) {
                    //smart follow up
                    reqData.rescheduledAction = ERescheduledAction.NEW_APPOINTMENT;
                    if (scheduleSmartFollowUpTime) {
                        //let startAtDayjs = dayjs(appointmentEventDetail?.startAt).add(scheduleSmartFollowUpValue, scheduleSmartFollowUpUnit as dayjs.ManipulateType).hour(scheduleSmartFollowUpTime.hour()).minute(scheduleSmartFollowUpTime.minute());
                        let startAtDayjs = dayjs(scheduleSmartFollowUpTime);
                        if (timezone) {
                            startAtDayjs = startAtDayjs.tz(timezone);
                        }
                        startAt = startAtDayjs.utc()
                            .format('YYYY-MM-DDTHH:mm:ss[Z]');
                        endAt = startAtDayjs.add(followUpDuration, 'minute').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
                        messageToPatient = scheduleSmartFollowUpText || '';
                    }
                    let appName: string = `${EServiceType.ESTABLISHED_PATIENT_VISIT}`;
                    if (appointmentEventDetail?.serviceSpecialty) {
                        appName = `${appointmentEventDetail?.serviceSpecialty}: ${appName}`;
                    }
                    if (targetClient) {
                        appName = `${targetClient.firstName} ${targetClient.lastName} - ${appName}`;
                    }
                    const targetESService = serviceItems?.find((service) => {
                        return service.serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT;
                    });
                    reqData.appointment = {
                        appointmentName: appName,
                        clientId: appointmentEventDetail?.clientId!,
                        startAt,
                        endAt,
                        duration: followUpDuration,
                        serviceType: EServiceType.ESTABLISHED_PATIENT_VISIT,
                        contactType: appointmentEventDetail?.contactType || EContactTypeV2.VIDEO,
                        serviceSpecialty: appointmentEventDetail?.serviceSpecialty || '',
                        externalVideoLink: appointmentEventDetail?.externalVideoLink || '',
                        location: appointmentEventDetail?.location || '',
                        calendarColor: targetESService?.color,
                        scheduledBy: EScheduledBy.PROVIDER_SCHEDULED,
                        appointmentStatus: EScheduleStatusValue.SCHEDULED,
                        telephone: appointmentEventDetail?.telephone || '',
                    };
                }
                if (selectScheduleItemIndex === 2) {
                    reqData.rescheduledAction = ERescheduledAction.ONLY_REMIND_PATIENT;
                    if (scheduleReminderTime) {
                        //// let startAtDayjs = dayjs(appointmentEventDetail?.startAt).add(scheduleReminderValue, scheduleReminderUnit as dayjs.ManipulateType).hour(scheduleReminderTime.hour()).minute(scheduleReminderTime.minute());
                        let startAtDayjs = dayjs(scheduleReminderTime);
                        if (timezone) {
                            startAtDayjs = startAtDayjs.tz(timezone);
                        }
                        startAt = startAtDayjs.utc()
                            .format('YYYY-MM-DDTHH:mm:ss[Z]');
                        messageToPatient = scheduleReminderText || '';
                    }
                }
                //reqData.emailSignature = sign;
                reqData.startAt = startAt;
                reqData.messageToPatient = messageToPatient;
            }
        }
        const result = await calendarUpdateAppointmentStatus(reqData);
        setUpdatingScheduleType(false);
        if (!result.error) {
            if (newStr === EScheduleStatusValue.PROVIDER_CANCELED) {
                message.success(successText || 'Appointment canceled successfully!');
            } else {
                message.success(successText || 'Update schedule status success!');
            }
            onSuccess?.();
            fetchDetail();
            setShowConfirmProviderCancelModal(false);
            setShowConfirmShowModal(false);
            setShowConfirmPatientNoShowOrLateCancelNoProtectModal(false);
            setShowConfirmPatientNoShowOrLateCancelProtectModal(false);
            setShowWaiveFeeMessage(false);
            setShowChargeFeeMessage(false);
        } else {
            setScheduleStatus(old);
        }
    };

    const handleAddOrEditBlocker = async (isEdit?: boolean) => {
        if (!timeVal && !allDay) {
            message.error('Please select time');
            return;
        }
        if (!blockDayStart) {
            message.error('Please select date');
            return;
        }
        if (allDay && !blockDayEnd) {
            message.error('Please select end date');
            return;
        }
        if (!duration && !allDay) {
            message.error('Please input duration');
            return;
        }
        let startDayjs: dayjs.Dayjs | undefined;
        let endDayjs: dayjs.Dayjs | undefined;

        if (timezone) {
            startDayjs = blockDayStart.clone().tz(timezone);
            endDayjs = blockDayEnd?.clone().tz(timezone);
        } else {
            startDayjs = blockDayStart.clone();
            endDayjs = blockDayEnd?.clone();
        }

        let startTime: string | undefined;
        let endTime: string | undefined;

        if (!allDay && timeVal) {
            startTime = startDayjs.hour(timeVal.fromHour!).minute(timeVal.fromMinute!).second(0).utc()
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
            endTime = startDayjs.hour(timeVal.toHour!).minute(timeVal.toMinute!).second(0).utc()
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        if (allDay) {
            startTime = startDayjs.startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
            endTime = endDayjs!.endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
        }
        const repeatDes = optionsRepeat.find((item) => item.value === repeatType)?.label;
        let byweekday = RRule.MO;
        const weekDay = startDayjs.day();
        const date = startDayjs.date();

        if (weekDay === 0) {
            byweekday = RRule.SU;
        }
        if (weekDay === 1) {
            byweekday = RRule.MO;
        }
        if (weekDay === 2) {
            byweekday = RRule.TU;
        }
        if (weekDay === 3) {
            byweekday = RRule.WE;
        }
        if (weekDay === 4) {
            byweekday = RRule.TH;
        }
        if (weekDay === 5) {
            byweekday = RRule.FR;
        }
        if (weekDay === 6) {
            byweekday = RRule.SA;
        }
        let repeatDayOfWeek = '';
        let recurrenceRule = '';

        if (repeatType === ERepeatType.DAILY) {
            const dailyRule = new RRule({
                freq: RRule.DAILY,
            });
            recurrenceRule = dailyRule.toString();
            repeatDayOfWeek = '1,2,3,4,5,6,7';
        }
        if (repeatType === ERepeatType.WEEKLY_ON_WEEKDAY) {
            const weeklyWednesdayRule = new RRule({
                freq: RRule.WEEKLY,
                byweekday,
            });
            recurrenceRule = weeklyWednesdayRule.toString();
            repeatDayOfWeek = `${weekDay}`;
        }

        if (repeatType === ERepeatType.MONTHLY_ON_FIRST_DAY) {
            const monthlyRule = new RRule({
                freq: RRule.MONTHLY,
                byweekday: [byweekday.nth(1)],
            });
            recurrenceRule = monthlyRule.toString();
        }

        if (repeatType === ERepeatType.MONTHLY_ON_DATE) {
            const monthlyRule = new RRule({
                freq: RRule.MONTHLY,
                bymonthday: date,
            });
            recurrenceRule = monthlyRule.toString();
        }

        if (repeatType === ERepeatType.EVERY_WEEKDAY) {
            const weeklyRule = new RRule({
                freq: RRule.WEEKLY,
                byweekday: [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR],
            });
            recurrenceRule = weeklyRule.toString();
            repeatDayOfWeek = '1,2,3,4,5';
        }

        let data: TServerCalendarBlockerEventDetail | undefined;
        if (allDay) {
            data = {
                title: blockTimeTitle,
                startAt: startTime!,
                endAt: endTime!,
                duration: dayjs(endTime!).diff(dayjs(startTime!), 'minute'),
                isAllDay: allDay,
                isDeclineAppointment: declineAll,
            };
        } else {
            data = {
                title: blockTimeTitle,
                startAt: startTime!,
                endAt: endTime!,
                duration,
                isAllDay: allDay,
                isDeclineAppointment: declineAll,
                repeatDesc: repeatDes,
                recurrenceRule,
                // repeatDayOfWeek: repeatDayOfWeek,
                // repeatDayOfMonth: currentRepeatType === ERepeatType.MONTHLY_ON_DATE ? date + '' : '',
                // repeatWeekOfMonth: currentRepeatType === ERepeatType.MONTHLY_ON_FIRST_DAY ? '1' : '',
            };
        }
        if (isEdit) {
            data.id = blockEventDetail?.id;
            if (blockEventDetail?.isSample) {
                data.title = `[Sample] ${data.title}`;
            }
        }
        if (timezone) {
            data.timezone = timezone;
        }
        setSubmiting(true);
        const result = await calendarCreateOrUpdateBlocker(data);
        setSubmiting(false);
        if (!result.error) {
            if (isEdit) {
                message.success('Update block time success!');
            } else {
                message.success('Create block time success!');
            }
            onSuccess?.();
        }
    };

    const handleRescheduleConfirm = async () => {
        if (!appointmentEventDetail || !rescheduleTime) {
            return;
        }
        const data: TServerCalendarAppointmentEventDetail | undefined = { ...appointmentEventDetail };
        const startDayjs = dayjs(rescheduleTime).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
        const endDayjs = dayjs(rescheduleTime).add(appointmentEventDetail.duration, 'minute').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
        data.startAt = startDayjs;
        data.endAt = endDayjs;
        setRescheduling(true);
        const result = await calendarCreateOrUpdateAppointment(data);
        setRescheduling(false);
        if (!result.error) {
            message.success('Appointment rescheduled successfully.');
            setShowRescheduleConfirmModal(false);
            setShowConfirmProviderCancelModal(false);
            onSuccess?.();
        }
    };

    const onOk = async () => {
        if (showAddApponitmentForm) {
            handleAddOrEditAppointment();
            return;
        }

        if (showEditAppointmentForm) {
            handleAddOrEditAppointment(true);
            return;
        }

        if (showAddBlockTimeForm) {
            handleAddOrEditBlocker();
        }

        if (showEditBlockTimeForm) {
            handleAddOrEditBlocker(true);
        }
    };

    const updateUiWithAppointmentEventDetail = (eventDetail?: TServerCalendarAppointmentEventDetail) => {
        if (!eventDetail) return;
        setCurrentSpecialty(eventDetail?.serviceSpecialty);
        setCurrentServiceType(eventDetail.serviceType);
        let startTimeDayjs = dayjs(eventDetail.startAt);
        let endTimeDayjs = dayjs(eventDetail.endAt);
        if (timezone) {
            startTimeDayjs = startTimeDayjs.tz(timezone);
            endTimeDayjs = endTimeDayjs.tz(timezone);
        }
        setAppointmentDate(startTimeDayjs);
        setDuration(eventDetail.duration);

        const timeVal: TimeItemType = {
            fromHour: startTimeDayjs.hour(),
            fromMinute: startTimeDayjs.minute(),
            toHour: endTimeDayjs.hour(),
            toMinute: endTimeDayjs.minute(),
        };
        setTimeVal(timeVal);
        setCurrentAppType(eventDetail.contactType || EContactTypeV2.VIDEO);
        setLocation(eventDetail.location || '');
        setMeetingLink(eventDetail.externalVideoLink || '');
        setPatientPhone(eventDetail.telephone || '');
        setClientId(eventDetail.clientId);
        setScheduleStatus(eventDetail.appointmentStatus || EScheduleStatusValue.SCHEDULED);
        setReason(eventDetail.reason || '');
        setPatientPhone(eventDetail.telephone || '');
    };

    const updateUiWithBlockerEventDetail = (eventDetail?: TServerCalendarBlockerEventDetail) => {
        if (!eventDetail) return;

        let startTimeDayjs = dayjs(eventDetail.startAt);
        let endTimeDayjs = dayjs(eventDetail.endAt);
        if (timezone) {
            startTimeDayjs = startTimeDayjs.tz(timezone);
            endTimeDayjs = endTimeDayjs.tz(timezone);
        }

        const weekDay = startTimeDayjs.day();
        const date = startTimeDayjs.date();
        let suffix = 'th';
        if (date === 1 || date === 21 || date === 31) {
            suffix = 'st';
        } else if (date === 2 || date === 22) {
            suffix = 'nd';
        } else if (date === 3 || date === 23) {
            suffix = 'rd';
        }
        let byweekday = RRule.MO;
        if (weekDay === 0) {
            byweekday = RRule.SU;
        }
        if (weekDay === 1) {
            byweekday = RRule.MO;
        }
        if (weekDay === 2) {
            byweekday = RRule.TU;
        }
        if (weekDay === 3) {
            byweekday = RRule.WE;
        }
        if (weekDay === 4) {
            byweekday = RRule.TH;
        }
        if (weekDay === 5) {
            byweekday = RRule.FR;
        }
        if (weekDay === 6) {
            byweekday = RRule.SA;
        }

        if (!eventDetail.recurrenceRule) {
            setRepeatType(ERepeatType.DOES_NOT_REPEAT);
            setRepeatText('Does not repeat');
        } else {
            const dailyRule = new RRule({
                freq: RRule.DAILY,
            });
            if (dailyRule.toString() === eventDetail.recurrenceRule) {
                setRepeatType(ERepeatType.DAILY);
                setRepeatText('Daily');
            }
            const weeklyWednesdayRule = new RRule({
                freq: RRule.WEEKLY,
                byweekday,
            });
            if (weeklyWednesdayRule.toString() === eventDetail.recurrenceRule) {
                setRepeatType(ERepeatType.WEEKLY_ON_WEEKDAY);
                setRepeatText(`Weekly on ${startTimeDayjs.format('dddd')}`);
            }
            const monthlyRule = new RRule({
                freq: RRule.MONTHLY,
                byweekday: [RRule.WE.nth(1)],
            });
            if (monthlyRule.toString() === eventDetail.recurrenceRule) {
                setRepeatType(ERepeatType.MONTHLY_ON_FIRST_DAY);
                setRepeatText(`Monthly on the first ${startTimeDayjs.format('dddd')}`);
            }

            const monthlyRule2 = new RRule({
                freq: RRule.MONTHLY,
                bymonthday: date,
            });
            if (monthlyRule2.toString() === eventDetail.recurrenceRule) {
                setRepeatType(ERepeatType.MONTHLY_ON_DATE);
                setRepeatText(`Monthly on the ${date}th`);
            }

            const weeklyRule = new RRule({
                freq: RRule.WEEKLY,
                byweekday: [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR],
            });
            if (weeklyRule.toString() === eventDetail.recurrenceRule) {
                setRepeatType(ERepeatType.EVERY_WEEKDAY);
                setRepeatText('Every weekday (Monday to Friday)');
            }
        }
        const timeVal: TimeItemType = {
            fromHour: startTimeDayjs.hour(),
            fromMinute: startTimeDayjs.minute(),
            toHour: endTimeDayjs.hour(),
            toMinute: endTimeDayjs.minute(),
        };
        setBlockDayStart(dayjs(eventDetail.startAt));
        setBlockDayEnd(dayjs(eventDetail.endAt) || undefined);
        const duration = dayjs(eventDetail.endAt).diff(dayjs(eventDetail.startAt), 'minute');
        setDuration(duration);
        setBlockTimeTitle(eventDetail.title);
        setTimeVal(timeVal);
        setDeclineAll(eventDetail.isDeclineAppointment);
        setAllDay(eventDetail.isAllDay);
    };

    React.useEffect(() => {
        if (appointmentEventDetail) {
            setEmailSign(getProviderNameDisplay(getUser('data') as any) + (getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''));
            updateUiWithAppointmentEventDetail(appointmentEventDetail);

            setScheduleReminderTime(appointmentEventDetail?.startAt ? dayjs(appointmentEventDetail.startAt).add(14, 'days').valueOf() : undefined);
            setScheduleSmartFollowUpTime(appointmentEventDetail?.startAt ? dayjs(appointmentEventDetail.startAt).add(14, 'days').valueOf() : undefined);
        }
    }, [appointmentEventDetail, timezone]);

    React.useEffect(() => {
        if (blockEventDetail) {
            updateUiWithBlockerEventDetail(blockEventDetail);
        }
    }, [blockEventDetail]);

    const handleConfirmChange = () => {
        onOk();
    };

    const handleRemove = () => {
        if (isBlockEvent) {
            setShowConfirmRemoveBlockerModal(true);
            return;
        }
        setShowConfirmRemoveAppointmentModal(true);
    };

    const handleConfirmRemove = async () => {
        let result: any;
        setDeleting(true);
        if (isBlockEvent) {
            result = await deleteCalendarBlockerEvent(`${event?.id}`);
        } else {
            result = await deleteCalendarAppointmentEvent(`${event?.id}`);
        }
        setDeleting(false);
        if (!result.error) {
            if (isBlockEvent) {
                message.success('Delete block time success');
            } else {
                message.success('Delete appointment success');
            }
            onSuccess?.();
        }
        //setShowCancelModal(false);
    };

    const handleClickSendInvitation = async (id: string) => {
        setSendingInvitation(true);
        const result = await sendPatientPortalInvitation(id);
        setSendingInvitation(false);
        if (!result.error) {
            message.success('Send invitation success');
            setHasClickSendPatientPortalInvitation(true);
        }
    };

    const handleConfirmProviderCancel = async () => {
        setScheduleStatus(EScheduleStatusValue.PROVIDER_CANCELED);
        handleScheduleTypeChange(appointmentEventDetail?.appointmentStatus, EScheduleStatusValue.PROVIDER_CANCELED, false, 'Appointment canceled successfully');
    };

    const handleConfirmPatientCancel = async () => {
        setScheduleStatus(EScheduleStatusValue.PATIENT_CANCELED);
        handleScheduleTypeChange(appointmentEventDetail?.appointmentStatus, EScheduleStatusValue.PATIENT_CANCELED);
    };

    const updateDurationWithTimeVal = (timeVal?: TimeItemType) => {
        if (timeVal && timeVal.fromHour !== undefined && timeVal.fromMinute !== undefined && timeVal.toHour !== undefined && timeVal.toMinute !== undefined) {
            const mins = timeVal.toHour! * 60 + timeVal.toMinute! - timeVal.fromHour! * 60 - timeVal.fromMinute!;
            setDuration(mins);
        }
    };

    const updateTimeValWithDurationChange = (duration: number) => {
        if (timeVal && timeVal.fromHour !== undefined && timeVal.fromMinute !== undefined && duration) {
            const endHour = Math.floor((timeVal.fromHour * 60 + timeVal.fromMinute + duration) / 60);
            const endMinute = (timeVal.fromHour * 60 + timeVal.fromMinute + duration) % 60;

            setTimeVal({
                fromHour: timeVal.fromHour,
                fromMinute: timeVal.fromMinute,
                toHour: endHour,
                toMinute: endMinute,
            });
        }
    };

    let durationText = '';
    if (timeVal && timeVal.fromHour !== undefined && timeVal.fromMinute !== undefined && timeVal.toHour !== undefined && timeVal.toMinute !== undefined) {
        durationText = `${duration} mins`;
    }

    let appointmentViewTimeLabel = '';
    let appointmentViewDateLabel = '';
    if (appointmentEventDetail) {
        appointmentViewTimeLabel = `${dayjs(appointmentEventDetail.startAt).format(dayjs(appointmentEventDetail.startAt)?.hour() === 0 ? 'HH:mm' : 'hh:mm')} - ${dayjs(appointmentEventDetail.endAt).format('hh:mm A')}`;
        appointmentViewDateLabel = getTimeStr(dayjs(appointmentEventDetail?.startAt), 'dddd, MMMM D, YYYY');
        if (timezone) {
            appointmentViewTimeLabel = `${dayjs(appointmentEventDetail.startAt).tz(timezone).format(dayjs(appointmentEventDetail.startAt).tz(timezone)?.hour() === 0 ? 'HH:mm' : 'hh:mm')} - ${dayjs(appointmentEventDetail.endAt).tz(timezone).format('hh:mm A')}`;
            appointmentViewDateLabel = getTimeStr(dayjs(appointmentEventDetail?.startAt).tz(timezone), 'dddd, MMMM D, YYYY');
        }
    }

    if (isGoogleEvent) {
        appointmentViewTimeLabel = `${dayjs(event?.start?.dateTime).format(dayjs(event?.start?.dateTime)?.hour() === 0 ? 'HH:mm' : 'hh:mm')} - ${dayjs(event?.end?.dateTime).tz(timezone).format('hh:mm A')}`;
        appointmentViewDateLabel = getTimeStr(dayjs(event?.start?.dateTime), 'dddd, MMMM D, YYYY');
        if (timezone) {
            appointmentViewTimeLabel = `${dayjs(event?.start?.dateTime).tz(timezone).format(dayjs(event?.start?.dateTime)?.hour() === 0 ? 'HH:mm' : 'hh:mm')} - ${dayjs(event?.end?.dateTime).tz(timezone).format('hh:mm A')}`;
            appointmentViewDateLabel = getTimeStr(dayjs(event?.start?.dateTime).tz(timezone), 'dddd, MMMM D, YYYY');
        }
    }

    let blockerViewTimeLabel = ''; //old: `${blockDayStart?.format(blockDayStart.hour() === 0 ? 'HH:mm' : 'hh:mm')} - ${blockDayEnd?.format('hh:mm A')}`
    let blockerViewDateLabel = ''; //old: getTimeStr(dayjs(blockEventDetail?.startAt), 'dddd, MMMM D, YYYY')
    if (blockEventDetail) {
        blockerViewTimeLabel = `${dayjs(blockEventDetail.startAt).format(dayjs(blockEventDetail.startAt)?.hour() === 0 ? 'HH:mm' : 'hh:mm')} - ${dayjs(blockEventDetail.endAt).format('hh:mm A')}`;
        blockerViewDateLabel = getTimeStr(dayjs(blockEventDetail?.startAt), 'dddd, MMMM D, YYYY');
        if (blockEventDetail.isAllDay) {
            blockerViewDateLabel = `${getTimeStr(dayjs(blockEventDetail?.startAt), 'dddd, MMMM D, YYYY')} - ${getTimeStr(dayjs(blockEventDetail?.endAt), 'dddd, MMMM D, YYYY')}`;
        }
    }
    if (timezone && blockEventDetail) {
        blockerViewTimeLabel = `${dayjs(blockEventDetail.startAt).tz(timezone).format(dayjs(blockEventDetail.startAt)?.hour() === 0 ? 'HH:mm' : 'hh:mm')} - ${dayjs(blockEventDetail.endAt).tz(timezone).format('hh:mm A')}`;
        blockerViewDateLabel = getTimeStr(dayjs(blockEventDetail?.startAt).tz(timezone), 'dddd, MMMM D, YYYY');
    }

    let hasModifiedDateAndTime = false;

    let modifiedDateAndTimeTextLabelOrg = '';
    let modifiedDateAndTimeTextLabelNew = '';
    let modifiedDateAndTimeTextOrg = '';
    let modifiedDateAndTimeTextNew = '';

    let hasModifiedAppType = false;
    let modifiedAppTypeTextLabelOrg = '';
    let modifiedAppTypeTextLabelNew = '';
    let modifiedAppTypeTextOrg = '';
    let modifiedAppTypeTextNew = '';

    let hasModifiedMeetingLink = false;
    let hasModifiedLocation = false;
    const hasModifiedPhone = false;

    let modifiedMeetingLinkOrLocationOrPhoneLabelOrg = '';
    let modifiedMeetingLinkOrLocationOrPhoneLabelNew = '';
    let modifiedMeetingLinkOrLocationOrPhoneTextOrg = '';
    let modifiedMeetingLinkOrLocationOrPhoneTextNew = '';

    let emailChangeDes1 = '';
    let emailChangeDes2Line1Label = '';
    let emailChangeDes2Line1Value = '';
    let emailChangeDes2Line2Label = '';
    let emailChangeDes2Line2Value = '';

    let emailChangeDes2Line3Label = '';
    let emailChangeDes2Line3Value = '';
    let emailChangeDes2Line4Label = '';
    let emailChangeDes2Line4Value = '';

    let emailChangeDes3 = '';

    let showExtraInput = false;

    if (appointmentEventDetail) {
        const startTime = appointmentEventDetail.startAt;
        if (appointmentDate && startTime) {
            const startTimeDayjs = dayjs(startTime);
            if (appointmentDate.date() !== startTimeDayjs.date() || appointmentDate.month() !== startTimeDayjs.month()) {
                hasModifiedDateAndTime = true;
            }
            if (duration && duration !== appointmentEventDetail.duration) {
                hasModifiedDateAndTime = true;
            }
            if (hasModifiedDateAndTime && duration) {
                modifiedDateAndTimeTextLabelOrg = 'Original date & time';
                modifiedDateAndTimeTextLabelNew = 'Updated date & time';
                modifiedDateAndTimeTextOrg = `${dayjs(appointmentEventDetail.startAt).format(dayjs(appointmentEventDetail.startAt)?.hour() === 0 ? 'dddd, MMMM D, YYYY HH:mm' : 'dddd, MMMM D, YYYY hh:mm')} - ${dayjs(appointmentEventDetail.endAt).format('hh:mm A')}`;
                const formatStr = dayjs(appointmentDate)?.hour() === 0 ? 'dddd, MMMM D, YYYY HH:mm' : 'dddd, MMMM D, YYYY hh:mm';
                modifiedDateAndTimeTextNew = `${dayjs(appointmentDate).hour(timeVal?.fromHour!).minute(timeVal?.fromMinute!).second(0)
                    .format(formatStr)} - ${dayjs(appointmentDate).hour(timeVal?.toHour!).minute(timeVal?.toMinute!).second(0)
                    .format('hh:mm A')}`;
            }
        }
        if (appointmentEventDetail.contactType !== currentAppType) {
            hasModifiedAppType = true;
            modifiedAppTypeTextLabelOrg = 'Original visit type';
            modifiedAppTypeTextLabelNew = 'Updated visit type';
            let orgText = '';
            let newText = '';
            if (appointmentEventDetail.contactType === EContactTypeV2.VIDEO) {
                orgText = appointmentEventDetail.externalVideoLink || '';
            }
            if (appointmentEventDetail.contactType === EContactTypeV2.IN_PERSON) {
                orgText = appointmentEventDetail.location || '';
            }
            if (appointmentEventDetail.contactType === EContactTypeV2.TELEPHONE) {
                orgText = appointmentEventDetail.telephone || '';
            }

            if (currentAppType === EContactTypeV2.VIDEO) {
                newText = meetingLink;
            }
            if (currentAppType === EContactTypeV2.IN_PERSON) {
                newText = location;
            }
            if (currentAppType === EContactTypeV2.TELEPHONE) {
                newText = patientPhone;
            }
            modifiedAppTypeTextOrg = `${getContactTypeLabel(appointmentEventDetail.contactType)}: ${orgText}`;
            modifiedAppTypeTextNew = `${getContactTypeLabel(currentAppType)}: ${newText}`;
        } else {
            if (appointmentEventDetail.contactType === EContactTypeV2.VIDEO && meetingLink !== appointmentEventDetail.externalVideoLink) {
                hasModifiedMeetingLink = true;
                modifiedMeetingLinkOrLocationOrPhoneLabelOrg = '';
                modifiedMeetingLinkOrLocationOrPhoneLabelNew = 'New meeting link';
                modifiedMeetingLinkOrLocationOrPhoneTextOrg = '';
                modifiedMeetingLinkOrLocationOrPhoneTextNew = meetingLink || '';
            }
            if (appointmentEventDetail.contactType === EContactTypeV2.IN_PERSON && location !== appointmentEventDetail.location) {
                hasModifiedLocation = true;
                modifiedMeetingLinkOrLocationOrPhoneLabelOrg = '';
                modifiedMeetingLinkOrLocationOrPhoneLabelNew = 'New location';
                modifiedMeetingLinkOrLocationOrPhoneTextOrg = '';
                modifiedMeetingLinkOrLocationOrPhoneTextNew = location || '';
            }
        }
    }

    if (hasModifiedDateAndTime && !hasModifiedAppType && !hasModifiedMeetingLink && !hasModifiedLocation && !hasModifiedPhone) {
        //Your |APPOINTMENT TYPE| originally scheduled for |ORIGINAL_DATE| at |ORIGINAL_TIME| has been rescheduled. Here are your new appointment details:
        emailChangeDes1 = `Your ${appointmentEventDetail?.serviceType} originally scheduled for ${dayjs(appointmentEventDetail?.startAt).format('dddd, MMMM D, YYYY')} at ${dayjs(appointmentEventDetail?.startAt).format('HH:mm')} has been rescheduled. Here are your new appointment details:`;
        emailChangeDes2Line1Label = 'Original date & time:';
        emailChangeDes2Line1Value = modifiedDateAndTimeTextOrg;
        emailChangeDes2Line2Label = 'Updated date & time:';
        emailChangeDes2Line2Value = modifiedDateAndTimeTextNew;
        emailChangeDes3 = 'If the new time doesn’t work for you, you can reschedule directly from your patient portal or reach out to me.';
        showExtraInput = true;
    } else if (hasModifiedDateAndTime && hasModifiedAppType) {
        emailChangeDes1 = `Your upcoming appointment on ${dayjs(appointmentEventDetail?.startAt).format('dddd, MMMM D, YYYY')} at ${dayjs(appointmentEventDetail?.startAt).format('HH:mm')} with provider ${getProviderNameDisplay(getUser('data'))} has been updated. Please review the new appointment details below:`;
        emailChangeDes2Line1Label = 'Original date & time:';
        emailChangeDes2Line1Value = modifiedDateAndTimeTextOrg;
        emailChangeDes2Line2Label = 'Updated date & time:';
        emailChangeDes2Line2Value = modifiedDateAndTimeTextNew;
        emailChangeDes2Line3Label = 'Original visit type:';
        emailChangeDes2Line3Value = modifiedAppTypeTextOrg;
        emailChangeDes2Line4Label = 'Updated visit type:';
        emailChangeDes2Line4Value = modifiedAppTypeTextNew;
        emailChangeDes3 = 'If you have any questions or need to make changes, feel free to reach out.';
    } else if (!hasModifiedDateAndTime && hasModifiedAppType) {
        emailChangeDes1 = `The meeting method for your upcoming appointment on ${dayjs(appointmentEventDetail?.startAt).format('dddd, MMMM D, YYYY')} at ${dayjs(appointmentEventDetail?.startAt).format('HH:mm')} has been updated. Please review the new appointment details below:`;
        emailChangeDes2Line1Label = 'Original visit type:';
        emailChangeDes2Line1Value = modifiedAppTypeTextOrg;
        emailChangeDes2Line2Label = 'Updated visit type:';
        emailChangeDes2Line2Value = modifiedAppTypeTextNew;
        emailChangeDes3 = 'If you have any questions or need to make changes, feel free to reach out.';
    } else if (hasModifiedDateAndTime && !hasModifiedAppType) {
        emailChangeDes1 = `Your upcoming appointment on ${dayjs(appointmentEventDetail?.startAt).format('dddd, MMMM D, YYYY')} at ${dayjs(appointmentEventDetail?.startAt).format('HH:mm')} with provider ${getProviderNameDisplay(getUser('data'))} has been updated. Please review the new appointment details below:`;
        emailChangeDes2Line1Label = 'Original date & time:';
        emailChangeDes2Line1Value = modifiedDateAndTimeTextOrg;
        emailChangeDes2Line2Label = 'Updated date & time:';
        emailChangeDes2Line2Value = modifiedDateAndTimeTextNew;

        if (hasModifiedMeetingLink) {
            emailChangeDes2Line4Label = 'New meeting link:';
            emailChangeDes2Line4Value = meetingLink;
            emailChangeDes3 = 'Please use this updated link to join your appointment. If you have any questions or need assistance, feel free to reach out.';
        } else if (hasModifiedLocation) {
            emailChangeDes2Line4Label = 'New location:';
            emailChangeDes2Line4Value = location;
            emailChangeDes3 = 'If you have any questions or need to make changes, feel free to reach out.';
        }
    } else if (!hasModifiedDateAndTime && !hasModifiedAppType) {
        //The meeting link for your upcoming appointment with |PROVIDER_NAME| on |APPOINTMENT_DATE| at |APPOINTMENT_TIME| has been updated.
        if (hasModifiedMeetingLink) {
            emailChangeDes1 = `The meeting link for your upcoming appointment with ${getProviderNameDisplay(getUser('data'))} on ${appointmentViewDateLabel} at ${appointmentViewTimeLabel} has been updated.`;
            emailChangeDes2Line2Label = 'New meeting link:';
            emailChangeDes2Line2Value = meetingLink;
            emailChangeDes3 = 'Please use this updated link to join your appointment. If you have any questions or need assistance, feel free to reach out.';
        } else if (hasModifiedLocation) {
            emailChangeDes1 = `The location for your upcoming appointment with ${getProviderNameDisplay(getUser('data'))} on ${appointmentViewDateLabel} at ${appointmentViewTimeLabel} has been updated.`;
            emailChangeDes2Line2Label = 'New location:';
            emailChangeDes2Line2Value = location;
            emailChangeDes3 = 'Please make sure to arrive a few minutes early and bring any necessary documents with you. If you have any questions or need assistance, feel free to reach out.';
        }
    }

    const handleSaveChange = () => {
        if (hasModifiedDateAndTime || hasModifiedAppType || hasModifiedMeetingLink || hasModifiedLocation) {
            setShowConfirmChangeNoteModal(true);
        } else {
            onOk();
        }
    };

    //onshow

    const hasState = !!(appointmentEventDetail && appointmentEventDetail.serviceState); //not self create
    const hasSpeciality = !!(appointmentEventDetail && appointmentEventDetail.serviceSpecialty);
    const targetEstablishedService = serviceData?.find((item) => {
        if (hasState && hasSpeciality) {
            return item.state?.toLowerCase() === appointmentEventDetail?.serviceState?.toLowerCase() &&
                item.serviceSpecialtyName?.toLowerCase() === appointmentEventDetail?.serviceSpecialty?.toLowerCase() &&
                item.serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT;
        }
        if (hasState) {
            return item.state?.toLowerCase() === appointmentEventDetail?.serviceState?.toLowerCase() &&
                item.serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT;
        }
        if (hasSpeciality) {
            return item.serviceSpecialtyName?.toLowerCase() === appointmentEventDetail?.serviceSpecialty?.toLowerCase() &&
                item.serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT;
        }

        return false;
    });

    let showLinkToServiceSetting = (hasState || hasSpeciality) && !targetEstablishedService;
    let canFollowUp = !showLinkToServiceSetting;
    let followUpDuration = targetEstablishedService?.duration || appointmentEventDetail?.duration || 15;

    if (appointmentEventDetail && appointmentEventDetail.serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT) {
        //specailty type
        showLinkToServiceSetting = false;
        canFollowUp = true;
        followUpDuration = appointmentEventDetail?.duration || 15;
    }
    if (!hasState && !hasSpeciality) {
        showLinkToServiceSetting = false;
        canFollowUp = true;
        followUpDuration = appointmentEventDetail?.duration || 15;
    }
    let followUpServiceLabel = '';
    if (appointmentEventDetail) {
        if (appointmentEventDetail.serviceState) {
            followUpServiceLabel = `${followUpServiceLabel}[${appointmentEventDetail.serviceState}]`;
        }
        if (appointmentEventDetail.serviceSpecialty) {
            followUpServiceLabel = `${followUpServiceLabel} ${appointmentEventDetail.serviceSpecialty}:`;
        }
        followUpServiceLabel = `${followUpServiceLabel} Follow-up`;
        followUpServiceLabel = `${followUpServiceLabel} | ${followUpDuration} mins`;
        followUpServiceLabel = followUpServiceLabel.trim();
    }
    //todo remove
    // showLinkToServiceSetting = true;
    // canFollowUp = false;
    const timeZoneLabel = timezone || myTimezone?.value;
    let scheduleReminderDateLabel = '';
    let scheduleReminderTimeLabel = '';
    if (scheduleReminderTime) {
        try {
            // let reminderDayjs = dayjs(appointmentEventDetail?.startAt).add(scheduleReminderValue, scheduleReminderUnit?.toLowerCase() as any).hour(scheduleReminderTime?.hour()!).minute(scheduleReminderTime?.minute()!)
            //     .second(0);
            let reminderDayjs = dayjs(scheduleReminderTime);
            if (timezone) {
                reminderDayjs = reminderDayjs.tz(timezone);
            }
            //Sunday, March 2, 2025
            //0:00 - 10:15 am
            scheduleReminderDateLabel = reminderDayjs.format('dddd, MMMM D, YYYY');
            scheduleReminderTimeLabel = `${reminderDayjs.format(reminderDayjs.hour() === 0 ? 'HH:mm' : 'hh:mm')} - ${reminderDayjs.add(followUpDuration || 15, 'minute').format(reminderDayjs.hour() === 0 ? 'HH:mm' : 'hh:mm A')}`;
            scheduleReminderTimeLabel = `${scheduleReminderTimeLabel} | ${followUpDuration} mins`;
        } catch (e) {
            console.error('Error calculating schedule reminder date:', e);
            scheduleReminderDateLabel = '';
        }
    }

    let scheduleSmartFollowUpDateLabel = '';
    let scheduleSmartFollowUpTimeLabel = '';
    if (scheduleSmartFollowUpTime) {
        try {
            // let smartFollowDayjs = dayjs(appointmentEventDetail?.startAt).add(scheduleSmartFollowUpValue, scheduleSmartFollowUpUnit?.toLowerCase() as any).hour(scheduleSmartFollowUpTime?.hour()!).minute(scheduleSmartFollowUpTime?.minute()!)
            //     .second(0);
            let smartFollowDayjs = dayjs(scheduleSmartFollowUpTime);
            if (timezone) {
                smartFollowDayjs = smartFollowDayjs.tz(timezone);
            }
            //Sunday, March 2, 2025
            //0:00 - 10:15 am
            scheduleSmartFollowUpDateLabel = smartFollowDayjs.format('dddd, MMMM D, YYYY');
            scheduleSmartFollowUpTimeLabel = `${smartFollowDayjs.format(smartFollowDayjs.hour() === 0 ? 'HH:mm' : 'hh:mm')} - ${smartFollowDayjs.add(followUpDuration || 0, 'minute').format(smartFollowDayjs.hour() === 0 ? 'HH:mm' : 'hh:mm A')}`;
            scheduleSmartFollowUpTimeLabel = `${scheduleSmartFollowUpTimeLabel} | ${followUpDuration} mins`;
        } catch (e) {
            console.error('Error calculating schedule reminder date:', e);
            scheduleReminderDateLabel = '';
        }
    }

    const scheduleReminderValueError = scheduleReminderValue !== undefined && scheduleReminderValue <= 0;
    const scheduleSmartFollowUpValueError = scheduleSmartFollowUpValue !== undefined && scheduleSmartFollowUpValue <= 0;
    let changeToShowDisabled = false;
    if (selectScheduleItemIndex === 1) {
        changeToShowDisabled = scheduleSmartFollowUpValueError || !emailSign;
    } else if (selectScheduleItemIndex === 2) {
        changeToShowDisabled = scheduleReminderValueError || !emailSign;
    }

    React.useEffect(() => {
        if (!appointmentEventDetail || appointmentEventDetail.appointmentStatus !== EScheduleStatusValue.SCHEDULED || !canFollowUp) {
            return;
        }
        const startAt = dayjs().add(-1, 'days').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
        const endAt = dayjs().add(60, 'days').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
        const fetchData = async () => {
            setLoadingTimeSlot(true);
            const res = await getProviderTimeSlotByLength({ startAt, endAt, length: followUpDuration || 15 });
            setLoadingTimeSlot(false);
            if (!res.error) {
                const serverSlog: { date: string, length: string }[] = res.data?.data?.timeSlots;
                const addTime: number[] = [];
                serverSlog?.forEach((item) => {
                    const date = item.date?.replace(' +0000', 'Z');
                    if ((new Date(date).getTime() > new Date().getTime())) {
                        addTime.push(dayjs(date).valueOf());
                    }
                });
                setTimeSlotList(addTime);
                //find default time
                const expectTime = dayjs(appointmentEventDetail.startAt).add(14, 'days').valueOf();
                const expectRescheduleTime = dayjs(appointmentEventDetail.startAt).add(1, 'days').valueOf();
                let defaultTimeForFollowUp = 0;
                let defaultTimeForRechedule = 0;
                addTime.forEach((item) => {
                    if (Math.abs(item - expectTime) < Math.abs(defaultTimeForFollowUp - expectTime)) {
                        defaultTimeForFollowUp = item;
                    }
                    if (Math.abs(item - expectRescheduleTime) < Math.abs(defaultTimeForRechedule - expectRescheduleTime)) {
                        defaultTimeForRechedule = item;
                    }
                });

                setDefaultNextFollowUpTime(defaultTimeForFollowUp);
                setDefaultRescheduleTime(defaultTimeForRechedule);
            }
        };
        fetchData();
    }, [appointmentEventDetail, canFollowUp, followUpDuration]);
    //end on show

    //provider cancel and reschedule
    let rescheduleServiceLabel = '';
    if (appointmentEventDetail) {
        if (appointmentEventDetail.serviceState) {
            rescheduleServiceLabel = `${rescheduleServiceLabel}[${appointmentEventDetail.serviceState}]`;
        }
        if (appointmentEventDetail.serviceSpecialty) {
            rescheduleServiceLabel = `${rescheduleServiceLabel} ${appointmentEventDetail.serviceSpecialty}:`;
        }
        if (appointmentEventDetail.serviceType) {
            rescheduleServiceLabel = `${rescheduleServiceLabel} ${appointmentEventDetail.serviceType}`;
        }
        if (appointmentEventDetail.duration) {
            rescheduleServiceLabel = `${rescheduleServiceLabel} | ${appointmentEventDetail.duration} mins`;
        }
        rescheduleServiceLabel = rescheduleServiceLabel.trim();
    }

    let rescheduleDateLabel = '';
    let rescheduleTimeLabel = '';
    if (rescheduleTime) {
        try {
            // let smartFollowDayjs = dayjs(appointmentEventDetail?.startAt).add(scheduleSmartFollowUpValue, scheduleSmartFollowUpUnit?.toLowerCase() as any).hour(scheduleSmartFollowUpTime?.hour()!).minute(scheduleSmartFollowUpTime?.minute()!)
            //     .second(0);
            let rescheduleDayjs = dayjs(rescheduleTime);
            if (timezone) {
                rescheduleDayjs = rescheduleDayjs.tz(timezone);
            }
            //Sunday, March 2, 2025
            //0:00 - 10:15 am
            rescheduleDateLabel = rescheduleDayjs.format('dddd, MMMM D, YYYY');
            rescheduleTimeLabel = `${rescheduleDayjs.format(rescheduleDayjs.hour() === 0 ? 'HH:mm' : 'hh:mm')} - ${rescheduleDayjs.add(appointmentEventDetail?.duration || 0, 'minute').format(rescheduleDayjs.hour() === 0 ? 'HH:mm' : 'hh:mm A')}`;
        } catch (e) {
            console.error('Error calculating schedule reminder date:', e);
            rescheduleDateLabel = '';
            rescheduleTimeLabel = '';
        }
    }

    if (isEdit && !appointmentEventDetail && !blockEventDetail && !isGoogleEvent) {
        //loading
        return (
            <div className={s.wrapLoading}>
                <Spin />
            </div>
        );
    }

    return (
        <div className={`${s.wrap} ${(showEditBlockTimeView || showEditBlockTimeForm || isGoogleEvent || isCanceled) ? s.wrapAutoHeight : ''} ${isPopLayer ? s.wrapPopLayer : ''}`}>
            {
                timezone &&
                <Tag className={s.timezone} style={{ marginLeft: '0px' }} color="blue">{timezone}</Tag>
            }
            {
                !isEdit &&
                <div className={s.navWrap}>
                    <div
                        onClick={() => {
                            setMode(1);
                        }}
                        className={`${s.item} ${mode === 1 ? s.itemAt : ''}`}
                    >
                        Appointment
                    </div>
                    <div
                        onClick={() => {
                            setMode(2);
                        }}
                        className={`${s.item} ${mode === 2 ? s.itemAt : ''}`}
                    >
                        Block time
                    </div>
                </div>
            }
            <div className={s.content}>
                {
                    showAddApponitmentForm &&
                    <div className={s.appWrap}>
                        <div className={s.item}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path d="M16 7.5C16 9.70914 14.2091 11.5 12 11.5C9.79086 11.5 8 9.70914 8 7.5C8 5.29086 9.79086 3.5 12 3.5C14.2091 3.5 16 5.29086 16 7.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 14.5C8.13401 14.5 5 17.634 5 21.5H19C19 17.634 15.866 14.5 12 14.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <Select
                                showSearch
                                onChange={(val) => {
                                    setClientId(val);
                                }}
                                value={clientId}
                                filterOption={(input, option) => {
                                    const name = option?.children?.join('');
                                    if (!name) return true;
                                    return name?.toLowerCase().indexOf(input?.toLowerCase()) >= 0;
                                }}
                                placeholder="Select a client"
                                style={{ width: '200px' }}
                            >
                                {
                                    clientOption?.map((item: Prospect) => {
                                        return (
                                            <Select.Option value={item.id} key={item.id}>
                                                {item.firstName} {item.lastName}
                                            </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                            {
                                targetClient &&
                                <div className={s.protectTagWrap}>
                                    {
                                        !isCurrentClientProtect &&
                                        <span className={s.unProtectTag}>
                                            Credit card pending
                                        </span>
                                    }
                                    {
                                        isCurrentClientProtect &&
                                        <span className={s.protectTag}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M13.3661 4.23431C13.6785 4.54673 13.6785 5.05327 13.3661 5.36569L6.96608 11.7657C6.65366 12.0781 6.14713 12.0781 5.83471 11.7657L2.63471 8.56569C2.32229 8.25327 2.32229 7.74673 2.63471 7.43431C2.94712 7.1219 3.45366 7.1219 3.76608 7.43431L6.40039 10.0686L12.2347 4.23431C12.5471 3.9219 13.0537 3.9219 13.3661 4.23431Z" fill="#00816B" />
                                            </svg>
                                            Credit card on file
                                        </span>
                                    }
                                </div>
                            }
                            <span
                                onClick={() => {
                                    setShowAddClient(true);
                                }}
                                className={s.create}
                            >
                                Create new client
                            </span>
                        </div>
                        <div className={s.item}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path d="M8 7.5V3.5M16 7.5V3.5M7 11.5H17M5 21.5H19C20.1046 21.5 21 20.6046 21 19.5V7.5C21 6.39543 20.1046 5.5 19 5.5H5C3.89543 5.5 3 6.39543 3 7.5V19.5C3 20.6046 3.89543 21.5 5 21.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <DatePicker
                                onChange={(val) => {
                                    setAppointmentDate(val || undefined);
                                }}
                                style={{ width: '250px' }}
                                value={appointmentDate}
                                format="dddd, MMM D, YYYY"
                            />
                        </div>
                        <div className={s.item}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path d="M12 8.5V12.5L15 15.5M21 12.5C21 17.4706 16.9706 21.5 12 21.5C7.02944 21.5 3 17.4706 3 12.5C3 7.52944 7.02944 3.5 12 3.5C16.9706 3.5 21 7.52944 21 12.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className={s.timeSelectWrap}>
                                <TimeSelect
                                    value={timeVal}
                                    minuteStep={15}
                                    onChange={handleTimeValChange}
                                />
                            </div>

                            <div className={s.durationText}>
                                {durationText}
                            </div>
                            {/* <InputNumber
                                value={duration}
                                controls={false}
                                step={0}
                                min={15}
                                onChange={(val) => {
                                    const value = val || 0;
                                    setDuration(value);
                                    updateTimeValWithDurationChange(value);
                                }}
                                style={{ width: '80px', marginLeft: '12px', marginRight: '8px' }}
                            /> */}
                            {/* mins */}
                        </div>
                        <div className={s.item}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path d="M17.6569 17.1569C16.7202 18.0935 14.7616 20.0521 13.4138 21.3999C12.6327 22.181 11.3677 22.1814 10.5866 21.4003C9.26234 20.076 7.34159 18.1553 6.34315 17.1569C3.21895 14.0327 3.21895 8.96734 6.34315 5.84315C9.46734 2.71895 14.5327 2.71895 17.6569 5.84315C20.781 8.96734 20.781 14.0327 17.6569 17.1569Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M15 11.5C15 13.1569 13.6569 14.5 12 14.5C10.3431 14.5 9 13.1569 9 11.5C9 9.84315 10.3431 8.5 12 8.5C13.6569 8.5 15 9.84315 15 11.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <Select
                                onChange={(val) => {
                                    setCurrentAppType(val);
                                }}
                                value={currentAppType}
                                placeholder="Select a type"
                                style={{ width: '200px' }}
                            >
                                {
                                    optionType.map((item) => {
                                        return (
                                            <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </div>
                        {
                            currentAppType === EContactTypeV2.VIDEO &&
                            <div className={s.itemUs}>
                                <Input
                                    maxLength={150}
                                    value={meetingLink}
                                    onChange={(e) => {
                                        setMeetingLink(e.target.value);
                                    }}
                                    className={s.input}
                                    placeholder="Add a meeting link"
                                />
                            </div>
                        }
                        {
                            currentAppType === EContactTypeV2.IN_PERSON &&
                            <div className={s.itemUs}>
                                <Input
                                    maxLength={150}
                                    value={location}
                                    onChange={(e) => {
                                        setLocation(e.target.value);
                                    }}
                                    className={s.input}
                                    placeholder="Add location"
                                />
                            </div>
                        }
                        {
                            currentAppType === EContactTypeV2.TELEPHONE &&
                            <div className={s.itemUs}>
                                <USPhoneInput
                                    value={patientPhone}
                                    onChange={(val) => {
                                        setPatientPhone(val as string);
                                    }}
                                    className={s.input}
                                    placeholder="Add patient phone number"
                                />
                            </div>
                        }
                        <div className={s.item}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path d="M21 13.7554C18.2207 14.8805 15.1827 15.5 12 15.5C8.8173 15.5 5.7793 14.8805 3 13.7554M16 6.5V4.5C16 3.39543 15.1046 2.5 14 2.5H10C8.89543 2.5 8 3.39543 8 4.5V6.5M12 12.5H12.01M5 20.5H19C20.1046 20.5 21 19.6046 21 18.5V8.5C21 7.39543 20.1046 6.5 19 6.5H5C3.89543 6.5 3 7.39543 3 8.5V18.5C3 19.6046 3.89543 20.5 5 20.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <Select
                                onChange={(val) => {
                                    setCurrentServiceType(val);
                                    if (!val) {
                                        return;
                                    }
                                    const target = serviceItems?.find((item) => item.serviceType === val);
                                    if (timeVal && timeVal.fromHour !== undefined && timeVal.fromMinute !== undefined && target && target.duration) {
                                        const endHour = Math.floor((timeVal.fromHour * 60 + timeVal.fromMinute + target.duration) / 60);
                                        const endMinute = (timeVal.fromHour * 60 + timeVal.fromMinute + target.duration) % 60;
                                        if (endHour > 23) {
                                            setTimeVal({
                                                fromHour: timeVal.fromHour,
                                                fromMinute: timeVal.fromMinute,
                                                toHour: 23,
                                                toMinute: 59,
                                            });
                                            updateDurationWithTimeVal({
                                                fromHour: timeVal.fromHour,
                                                fromMinute: timeVal.fromMinute,
                                                toHour: 23,
                                                toMinute: 59,
                                            });
                                            return;
                                        }
                                        setTimeVal({
                                            fromHour: timeVal.fromHour,
                                            fromMinute: timeVal.fromMinute,
                                            toHour: endHour,
                                            toMinute: endMinute,
                                        });
                                        updateDurationWithTimeVal({
                                            fromHour: timeVal.fromHour,
                                            fromMinute: timeVal.fromMinute,
                                            toHour: endHour,
                                            toMinute: endMinute,
                                        });
                                    }
                                }}
                                value={currentServiceType}
                                placeholder="Select service type"
                                style={{ width: '250px' }}
                            >
                                {
                                    optionServiceType.map((item) => {
                                        return (
                                            <Select.Option value={item.value} key={item.value}>{item.label}</Select.Option>
                                        );
                                    })
                                }
                            </Select>
                            <span
                                onClick={() => {
                                    setCurrentServiceType(undefined);
                                }}
                                className={s.removeType}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M6 18.5L18 6.5M6 6.5L18 18.5" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        </div>
                        <div className={s.item}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path d="M19 21.5V5.5C19 4.39543 18.1046 3.5 17 3.5H7C5.89543 3.5 5 4.39543 5 5.5V21.5M19 21.5L21 21.5M19 21.5H14M5 21.5L3 21.5M5 21.5H10M9 7.49998H10M9 11.5H10M14 7.49998H15M14 11.5H15M10 21.5V16.5C10 15.9477 10.4477 15.5 11 15.5H13C13.5523 15.5 14 15.9477 14 16.5V21.5M10 21.5H14" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <Select
                                onChange={(val) => {
                                    setCurrentSpecialty(val);
                                }}
                                showSearch
                                value={currentSpecialty}
                                placeholder="Select a specialty (optional)"
                                style={{ width: '320px' }}
                            >
                                {
                                    specialtiesOptions.map((item) => {
                                        return (
                                            <Select.Option value={item} key={item}>{item}</Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </div>
                    </div>
                }
                {
                    showAddBlockTimeForm &&
                    <div className={`${s.appWrap} ${s.blockWrap}`}>
                        <div className={s.item}>
                            <Input
                                style={{ width: '90%' }}
                                value={blockTimeTitle}
                                onChange={(e) => {
                                    setBlockTimeTitle(e.target.value);
                                }}
                            />
                        </div>
                        <div className={s.item}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path d="M8 7.5V3.5M16 7.5V3.5M7 11.5H17M5 21.5H19C20.1046 21.5 21 20.6046 21 19.5V7.5C21 6.39543 20.1046 5.5 19 5.5H5C3.89543 5.5 3 6.39543 3 7.5V19.5C3 20.6046 3.89543 21.5 5 21.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            {
                                !allDay &&
                                <DatePicker
                                    onChange={(val) => {
                                        setBlockDayStart(val || undefined);
                                    }}
                                    style={{ width: '250px' }}
                                    value={blockDayStart}
                                    format="dddd, MMM D, YYYY"
                                />
                            }
                            {
                                allDay &&
                                <DatePicker.RangePicker
                                    value={[blockDayStart || null, blockDayEnd || null]}
                                    onChange={(val) => {
                                        setBlockDayStart(val?.[0] || undefined);
                                        setBlockDayEnd(val?.[1] || undefined);
                                    }}
                                />
                            }
                        </div>
                        {
                            !allDay &&
                            <div className={s.item}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M12 8.5V12.5L15 15.5M21 12.5C21 17.4706 16.9706 21.5 12 21.5C7.02944 21.5 3 17.4706 3 12.5C3 7.52944 7.02944 3.5 12 3.5C16.9706 3.5 21 7.52944 21 12.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <div className={s.timeSelectWrap}>
                                    <TimeSelect
                                        minuteStep={15}
                                        value={timeVal}
                                        onChange={handleTimeValChange}
                                    />
                                </div>
                                <div className={s.durationText}>
                                    {durationText}
                                </div>
                                {/* <InputNumber
                                    min={15}
                                    step={0}
                                    onChange={(val) => {
                                        const value = val || 0;
                                        setDuration(value);
                                        updateTimeValWithDurationChange(value);
                                    }}
                                    value={duration}
                                    style={{ width: '80px', marginLeft: '12px', marginRight: '8px' }}
                                /> */}
                                {/* mins */}
                            </div>
                        }
                        <div className={s.item}>
                            <Checkbox
                                onChange={(e) => {
                                    setAllDay(e.target.checked);
                                }}
                                checked={allDay}
                                style={{ marginLeft: '4px' }}
                            >
                                All day
                            </Checkbox>
                        </div>
                        {
                            !allDay &&
                            <div className={s.item}>
                                <Select
                                    onChange={(val) => {
                                        setRepeatType(val);
                                    }}
                                    value={repeatType}
                                    placeholder="Select service type"
                                    style={{ width: '300px' }}
                                >
                                    {
                                        optionsRepeat.map((item) => {
                                            return (
                                                <Select.Option value={item.value} key={item.value}>{item.label}</Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </div>
                        }
                        <div className={s.item}>
                            <Checkbox
                                onChange={(e) => {
                                    setDeclineAll(e.target.checked);
                                }}
                                checked={declineAll}
                                style={{ marginLeft: '4px' }}
                            >
                                Decline all existing appointments
                            </Checkbox>
                        </div>
                    </div>
                }
                {
                    showEditAppointmentView &&
                    <div className={s.view}>
                        <div className={s.top}>
                            <div
                                className={s.tag}
                                style={{
                                    marginLeft: timezone ? '100px' : '0px',
                                }}
                            >
                                {tagText}
                            </div>
                            {/* todo remove */}
                            {
                                isLocalhost() &&
                                <span onClick={handleRemove}>
                                    Delete
                                </span>
                            }
                            {/* <span onClick={handleRemove}>
                                Delete
                            </span> */}
                            {
                                showEditButton &&
                                <div className={s.btnWrap}>
                                    <span
                                        onClick={() => {
                                            setIsViewOnly(false);
                                        }}
                                        className={s.btn}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M20.2677 3.73223L20.9748 3.02513V3.02513L20.2677 3.73223ZM6.5 21.0355V22.0355C6.76522 22.0355 7.01957 21.9301 7.20711 21.7426L6.5 21.0355ZM3 21.0355H2C2 21.5878 2.44772 22.0355 3 22.0355V21.0355ZM3 17.4644L2.29289 16.7573C2.10536 16.9448 2 17.1992 2 17.4644H3ZM17.4393 4.43934C18.0251 3.85355 18.9748 3.85355 19.5606 4.43934L20.9748 3.02513C19.608 1.65829 17.3919 1.65829 16.0251 3.02513L17.4393 4.43934ZM19.5606 4.43934C20.1464 5.02513 20.1464 5.97487 19.5606 6.56066L20.9748 7.97487C22.3417 6.60804 22.3417 4.39196 20.9748 3.02513L19.5606 4.43934ZM19.5606 6.56066L5.79289 20.3284L7.20711 21.7426L20.9748 7.97487L19.5606 6.56066ZM6.5 20.0355H3V22.0355H6.5V20.0355ZM16.0251 3.02513L2.29289 16.7573L3.70711 18.1715L17.4393 4.43934L16.0251 3.02513ZM2 17.4644V21.0355H4V17.4644H2ZM14.5251 5.93934L18.0606 9.47487L19.4748 8.06066L15.9393 4.52513L14.5251 5.93934Z" fill="#6B7280" />
                                        </svg>
                                    </span>
                                    <Popover
                                        trigger="hover"
                                        title=""
                                        content={
                                            <div
                                                className={s.popCancel}
                                                onClick={() => {
                                                    setShowConfirmProviderCancelModal(true);
                                                }}
                                            >Cancel appointment
                                            </div>
                                        }
                                        placement="bottomRight"
                                    >
                                        <span
                                            // onClick={handleRemove}
                                            className={s.btn}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M12.0004 7.1999C10.6749 7.1999 9.60039 6.12539 9.60039 4.7999C9.60039 3.47442 10.6749 2.3999 12.0004 2.3999C13.3259 2.3999 14.4004 3.47442 14.4004 4.7999C14.4004 6.12539 13.3259 7.1999 12.0004 7.1999Z" fill="#6B7280" />
                                                <path d="M12.0004 14.3999C10.6749 14.3999 9.60039 13.3254 9.60039 11.9999C9.60039 10.6744 10.6749 9.5999 12.0004 9.5999C13.3259 9.5999 14.4004 10.6744 14.4004 11.9999C14.4004 13.3254 13.3259 14.3999 12.0004 14.3999Z" fill="#6B7280" />
                                                <path d="M9.60039 19.1999C9.60039 20.5254 10.6749 21.5999 12.0004 21.5999C13.3259 21.5999 14.4004 20.5254 14.4004 19.1999C14.4004 17.8744 13.3259 16.7999 12.0004 16.7999C10.6749 16.7999 9.60039 17.8744 9.60039 19.1999Z" fill="#6B7280" />
                                            </svg>
                                        </span>
                                    </Popover>

                                </div>
                            }
                        </div>
                        <div className={s.viewContent}>
                            <div className={s.vTitle}>
                                {/* Appointment name: [Specialty icon] Patient name - [State] Specialty: Visit type */}
                                <span
                                    className={s.vTag}
                                    style={{
                                        backgroundColor: targetService?.color || DEFAULT_CALENDAR_COLOR,
                                    }}
                                />
                                <div className={s.vtVal}>
                                    {
                                        targetSpeciality && (
                                            <img className={s.speIcon} src={targetSpeciality.iconUrl} alt="" />
                                        )
                                    }

                                    {/* {eventClient?.firstName} {eventClient?.lastName} {' - '}
                                    {appointmentEventDetail?.serviceState ? `[${appointmentEventDetail?.serviceState}]` : ''} */}
                                    {isGoogleEvent ? event.summary : appointmentEventDetail?.appointmentName}
                                    {/* John Smith - [WA] Psychiatric & Mental health: Consultation */}
                                </div>
                            </div>
                            {
                                !isGoogleEvent &&
                                (
                                    <>
                                        <div className={s.vSelect}>
                                            <Select
                                                value={scheduleStatus}
                                                loading={updatingScheduleType}
                                                onChange={(val) => {
                                                    handleScheduleTypeChange(scheduleStatus, val, true);
                                                }}
                                                disabled={!canChangeStatus}
                                                style={{ width: '280px' }}
                                            >
                                                {
                                                    optionSchedule.map((item) => {
                                                        return (
                                                            <Select.Option
                                                                disabled={item.value === EScheduleStatusValue.PROVIDER_CANCELED}
                                                                value={item.value}
                                                                key={item.value}
                                                            >
                                                                <div className={s.vSelectItem}>
                                                                    {item.icon}
                                                                    {item.label}
                                                                    <span className={s.tipsItem}>
                                                                        <Popover
                                                                            zIndex={99999}
                                                                            placement="rightTop"
                                                                            content={<div className={s.toolTips}>{item.toolTips}</div>}
                                                                        >
                                                                            <svg style={{ marginLeft: '4px' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                <path d="M6.85638 7.5C7.31398 6.52901 8.54869 5.83333 10 5.83333C11.841 5.83333 13.3334 6.95262 13.3334 8.33333C13.3334 9.49953 12.2687 10.4792 10.8286 10.7555C10.3766 10.8422 10 11.2064 10 11.6667M10 14.1667H10.0083M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                            </svg>
                                                                        </Popover>
                                                                    </span>
                                                                </div>
                                                            </Select.Option>
                                                        );
                                                    })
                                                }
                                            </Select>
                                        </div>
                                        {
                                            (appointmentEventDetail?.appointmentStatus === EScheduleStatusValue.PROVIDER_CANCELED || appointmentEventDetail?.appointmentStatus === EScheduleStatusValue.PATIENT_CANCELED) && appointmentEventDetail?.providerAppointmentCancelInfo && appointmentEventDetail?.providerAppointmentCancelInfo.canceledReason &&
                                            <div className={s.cancelReasonView}>
                                                <div className={s.crTitle}>Cancellation reason</div>
                                                <div className={s.crContent}>
                                                    {appointmentEventDetail?.providerAppointmentCancelInfo.canceledReason}
                                                    {
                                                        appointmentEventDetail?.providerAppointmentCancelInfo.otherReason ? ` - ${appointmentEventDetail?.providerAppointmentCancelInfo.otherReason}` : ''
                                                    }
                                                    {
                                                        appointmentEventDetail?.providerAppointmentCancelInfo.manualReason ? `: ${appointmentEventDetail?.providerAppointmentCancelInfo.manualReason}` : ''
                                                    }
                                                </div>
                                                <div className={s.crMsgToPatient}>
                                                    <div className={s.crTitle}>Message to patient</div>
                                                    <div className={s.crContent}>
                                                        <div className={s.mtHeader}>
                                                            Dear {targetClient?.firstName},
                                                        </div>
                                                        <div className={s.mtDes}>
                                                            I wanted to let you know that your {currentServiceType} scheduled on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span>  has been canceled. I apologize for any inconvenience this may cause.
                                                        </div>
                                                        {
                                                            appointmentEventDetail?.providerAppointmentCancelInfo?.messageToPatient &&
                                                            <div className={s.mtCus}>
                                                                {appointmentEventDetail.providerAppointmentCancelInfo.messageToPatient}
                                                            </div>
                                                        }

                                                        <div className={s.mtFooter}>
                                                            <p>Best regards,</p>
                                                            <p>
                                                                {getProviderNameDisplay(getUser('data') as any)} {getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {
                                            appointmentEventDetail?.appointmentStatus === EScheduleStatusValue.PATIENT_NO_SHOW &&
                                            <div className={s.cancelReasonView}>
                                                <div className={s.crTitle}>No show fee</div>
                                                <div className={s.crContent}>
                                                    {chargetText}
                                                </div>
                                            </div>
                                        }
                                        {
                                            appointmentEventDetail?.appointmentStatus === EScheduleStatusValue.PATIENT_LATE_CANCELED &&
                                            <div className={s.cancelReasonView}>
                                                <div className={s.crTitle}>Late canceled fee</div>
                                                <div className={s.crContent}>
                                                    {chargetText}
                                                </div>
                                            </div>
                                        }
                                        {
                                            isProviderScheduleEvent &&
                                            <div className={s.vItem}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                    <path d="M16 7.5C16 9.70914 14.2091 11.5 12 11.5C9.79086 11.5 8 9.70914 8 7.5C8 5.29086 9.79086 3.5 12 3.5C14.2091 3.5 16 5.29086 16 7.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M12 14.5C8.13401 14.5 5 17.634 5 21.5H19C19 17.634 15.866 14.5 12 14.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                <span
                                                    onClick={() => {
                                                        if (eventClient) {
                                                            window.open(`${PATH.DASHBOARD}/${PATH.PROSPECTS_DETAIL}/${eventClient?.id}`, '_blank');
                                                        }
                                                    }}
                                                    className={s.clientName}
                                                >{eventClient?.firstName} {eventClient?.lastName}
                                                </span>

                                                {
                                                    !isProtect &&
                                                    <span className={s.unProtectTag}>
                                                        Credit card pending
                                                    </span>
                                                }
                                                {
                                                    isProtect &&
                                                    <span className={s.protectTag}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M13.3661 4.23431C13.6785 4.54673 13.6785 5.05327 13.3661 5.36569L6.96608 11.7657C6.65366 12.0781 6.14713 12.0781 5.83471 11.7657L2.63471 8.56569C2.32229 8.25327 2.32229 7.74673 2.63471 7.43431C2.94712 7.1219 3.45366 7.1219 3.76608 7.43431L6.40039 10.0686L12.2347 4.23431C12.5471 3.9219 13.0537 3.9219 13.3661 4.23431Z" fill="#00816B" />
                                                        </svg>
                                                        Credit card on file
                                                    </span>
                                                }
                                            </div>
                                        }
                                        {
                                            targetClient && !isProviderScheduleEvent && (
                                                <div className={s.clientWrap}>
                                                    <div className={s.cTop}>
                                                        <div className={s.left}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                            Client information
                                                        </div>
                                                        <div
                                                            className={s.right}
                                                        >
                                                            {
                                                                !isProtect &&
                                                                <span className={s.unProtectTag}>
                                                                    Credit card pending
                                                                </span>
                                                            }
                                                            {
                                                                isProtect &&
                                                                <span className={s.protectTag}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M13.3661 4.23431C13.6785 4.54673 13.6785 5.05327 13.3661 5.36569L6.96608 11.7657C6.65366 12.0781 6.14713 12.0781 5.83471 11.7657L2.63471 8.56569C2.32229 8.25327 2.32229 7.74673 2.63471 7.43431C2.94712 7.1219 3.45366 7.1219 3.76608 7.43431L6.40039 10.0686L12.2347 4.23431C12.5471 3.9219 13.0537 3.9219 13.3661 4.23431Z" fill="#00816B" />
                                                                    </svg>
                                                                    Credit card on file
                                                                </span>
                                                            }
                                                            <span
                                                                onClick={() => {
                                                                    window.open(`${PATH.DASHBOARD}/${PATH.PROSPECTS_DETAIL}/${targetClient.id}`, '_blank');
                                                                }}
                                                                className={s.viewBtn}
                                                            >View
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className={s.row}>
                                                        <div className={s.col} style={{ width: '33%' }}>
                                                            <div className={s.label}>First name</div>
                                                            <div className={s.val}>
                                                                {targetClient.firstName}
                                                            </div>
                                                        </div>
                                                        <div className={s.col} style={{ width: '33%' }}>
                                                            <div className={s.label}>Last name</div>
                                                            <div className={s.val}>
                                                                {targetClient.lastName || '-'}
                                                            </div>
                                                        </div>
                                                        <div className={s.col} style={{ width: '33%' }}>
                                                            <div className={s.label}>Preferred name</div>
                                                            <div className={s.val}>
                                                                {targetClient.preferredName || '-'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={s.row}>
                                                        <div className={s.col}>
                                                            <div className={s.label}>Reason for appointment</div>
                                                            <div className={s.val}>
                                                                {appointmentEventDetail?.reason || '-'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        appointmentEventDetail?.relationship === 'self' ?
                                                            <div className={s.row}>
                                                                <div className={s.col}>
                                                                    <div className={s.label}>Book for someone else?</div>
                                                                    <div className={s.val}>
                                                                        false
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className={s.row}>
                                                                <div className={s.col} style={{ width: '54%' }}>
                                                                    <div className={s.label}>Book for someone else?</div>
                                                                    <div className={s.val}>
                                                                        true
                                                                    </div>
                                                                </div>
                                                                <div className={s.col} style={{ width: '54%' }}>
                                                                    <div className={s.label}>Relationship to the client</div>
                                                                    <div className={s.val}>
                                                                        {appointmentEventDetail?.relationship || '-'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    }
                                                </div>
                                            )
                                        }
                                    </>
                                )
                            }
                            <div className={s.vItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                {appointmentViewDateLabel}
                            </div>
                            <div className={s.vItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                {appointmentViewTimeLabel}
                                {' '}
                                {myTimezone.value}
                                {' | '}
                                {isGoogleEvent ? dayjs(event.end.dateTime).diff(dayjs(event.start.dateTime), 'minutes') : duration}
                                {' mins'}
                            </div>
                            {
                                !isGoogleEvent &&
                                <div className={s.vItem}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M17.6569 16.6569C16.7202 17.5935 14.7616 19.5521 13.4138 20.8999C12.6327 21.681 11.3677 21.6814 10.5866 20.9003C9.26234 19.576 7.34159 17.6553 6.34315 16.6569C3.21895 13.5327 3.21895 8.46734 6.34315 5.34315C9.46734 2.21895 14.5327 2.21895 17.6569 5.34315C20.781 8.46734 20.781 13.5327 17.6569 16.6569Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {contactTypeText}
                                </div>
                            }
                            {
                                appointmentEventDetail?.contactType === EContactTypeV2.VIDEO && (
                                    <div className={s.vItem2}>
                                        <a href={appointmentEventDetail.externalVideoLink}>{appointmentEventDetail.externalVideoLink}</a>
                                    </div>
                                )
                            }
                            {
                                appointmentEventDetail?.contactType === EContactTypeV2.IN_PERSON && (
                                    <div className={s.vItem2}>
                                        {appointmentEventDetail?.location}
                                    </div>
                                )
                            }
                            {
                                appointmentEventDetail?.contactType === EContactTypeV2.TELEPHONE && (
                                    <div className={s.vItem2}>
                                        {appointmentEventDetail?.telephone}
                                    </div>
                                )
                            }
                            {
                                !isGoogleEvent && (
                                    <>
                                        <div className={s.vItem}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M21 13.2554C18.2207 14.3805 15.1827 15 12 15C8.8173 15 5.7793 14.3805 3 13.2554M16 6V4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4V6M12 12H12.01M5 20H19C20.1046 20 21 19.1046 21 18V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            {appointmentEventDetail?.serviceType}
                                        </div>
                                        <div className={s.vItem}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21L21 21M19 21H14M5 21L3 21M5 21H10M9 6.99998H10M9 11H10M14 6.99998H15M14 11H15M10 21V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V21M10 21H14" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            {appointmentEventDetail?.serviceSpecialty || '-'}
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                }

                {
                    showEditAppointmentForm &&
                    <div className={s.view}>
                        <div className={s.top}>
                            <div
                                className={s.tag}
                                style={{
                                    marginLeft: timezone ? '100px' : '8px',
                                }}
                            >
                                {tagText}
                            </div>
                            <div className={s.btnWrap}>
                                <Button
                                    onClick={() => {
                                        updateUiWithAppointmentEventDetail(appointmentEventDetail);
                                        //special case
                                        setScheduleStatus(scheduleStatus);
                                        setIsViewOnly(true);
                                    }}
                                    className={s.btn}
                                >
                                    Discard
                                </Button>
                                <Button
                                    onClick={handleSaveChange}
                                    loading={submiting && !showConfirmChangeNoteModal}
                                    className={s.btn}
                                    type="primary"
                                >
                                    Save
                                </Button>
                            </div>
                        </div>
                        <div className={s.viewContent}>
                            <div className={s.vTitle}>
                                {/* Appointment name: [Specialty icon] Patient name - [State] Specialty: Visit type */}
                                <span
                                    className={s.vTag}
                                    style={{
                                        backgroundColor: targetService?.color || DEFAULT_CALENDAR_COLOR,
                                    }}
                                />
                                <div className={s.vtVal}>
                                    <img src="" alt="" />
                                    {/* {eventClient?.firstName} {eventClient?.lastName} {' - '}
                                    {appointmentEventDetail?.serviceState ? `[${appointmentEventDetail?.serviceState}]` : ''} */}
                                    {appointmentEventDetail?.appointmentName}
                                    {/* John Smith - [WA] Psychiatric & Mental health: Consultation */}
                                </div>
                            </div>
                            <div className={s.vSelect}>
                                <Select
                                    value={scheduleStatus}
                                    loading={updatingScheduleType}
                                    onChange={(val) => {
                                        setScheduleStatus(val);
                                    }}
                                    disabled
                                    style={{ width: '280px' }}
                                >
                                    {
                                        optionSchedule.map((item) => {
                                            return (
                                                <Select.Option
                                                    value={item.value}
                                                    key={item.value}
                                                >
                                                    <div className={s.vSelectItem}>
                                                        {item.icon}
                                                        {item.label}
                                                    </div>
                                                </Select.Option>
                                            );
                                        })
                                    }

                                </Select>
                            </div>
                            {
                                isProviderScheduleEvent &&
                                <div className={s.vItem}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M16 7.5C16 9.70914 14.2091 11.5 12 11.5C9.79086 11.5 8 9.70914 8 7.5C8 5.29086 9.79086 3.5 12 3.5C14.2091 3.5 16 5.29086 16 7.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 14.5C8.13401 14.5 5 17.634 5 21.5H19C19 17.634 15.866 14.5 12 14.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <Select
                                        showSearch
                                        onChange={(val) => {
                                            setClientId(val);
                                        }}
                                        filterOption={(input, option) => {
                                            const name = option?.children?.join('');
                                            if (!name) return true;
                                            return name?.toLowerCase().indexOf(input?.toLowerCase()) >= 0;
                                        }}
                                        value={clientId}
                                        placeholder="Select a client"
                                        style={{ width: '200px' }}
                                    >
                                        {
                                            clientOption?.map((item: Prospect) => {
                                                return (
                                                    <Select.Option value={item.id} key={item.id}>
                                                        {item.firstName} {item.lastName}
                                                    </Select.Option>
                                                );
                                            })
                                        }
                                    </Select>
                                    <div className={s.protectTagWrap}>
                                        {
                                            !isCurrentClientProtect &&
                                            <span className={s.unProtectTag}>
                                                Credit card pending
                                            </span>
                                        }
                                        {
                                            isCurrentClientProtect &&
                                            <span className={s.protectTag}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M13.3661 4.23431C13.6785 4.54673 13.6785 5.05327 13.3661 5.36569L6.96608 11.7657C6.65366 12.0781 6.14713 12.0781 5.83471 11.7657L2.63471 8.56569C2.32229 8.25327 2.32229 7.74673 2.63471 7.43431C2.94712 7.1219 3.45366 7.1219 3.76608 7.43431L6.40039 10.0686L12.2347 4.23431C12.5471 3.9219 13.0537 3.9219 13.3661 4.23431Z" fill="#00816B" />
                                                </svg>
                                                Credit card on file
                                            </span>
                                        }
                                    </div>
                                    <span
                                        onClick={() => {
                                            setShowAddClient(true);
                                        }}
                                        className={s.create}
                                    >
                                        Create new client
                                    </span>
                                </div>
                            }
                            {
                                targetClient && !isProviderScheduleEvent && (
                                    <div className={s.clientWrap}>
                                        <div className={s.cTop}>
                                            <div className={s.left}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                <Select
                                                    showSearch
                                                    onChange={(val) => {
                                                        setClientId(val);
                                                    }}
                                                    disabled
                                                    value={clientId}
                                                    filterOption={(input, option) => {
                                                        const name = option?.children?.join('');
                                                        if (!name) return true;
                                                        return name?.toLowerCase().indexOf(input?.toLowerCase()) >= 0;
                                                    }}
                                                    placeholder="Select a client"
                                                    style={{ width: '200px' }}
                                                >
                                                    {
                                                        clientOption?.map((item: Prospect) => {
                                                            return (
                                                                <Select.Option value={item.id} key={item.id}>
                                                                    {item.firstName} {item.lastName}
                                                                </Select.Option>
                                                            );
                                                        })
                                                    }
                                                </Select>
                                            </div>
                                            <div className={s.right}>
                                                {
                                                    !isProtect &&
                                                    <span className={s.unProtectTag}>
                                                        Credit card pending
                                                    </span>
                                                }
                                                {
                                                    isProtect &&
                                                    <span className={s.protectTag}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M13.3661 4.23431C13.6785 4.54673 13.6785 5.05327 13.3661 5.36569L6.96608 11.7657C6.65366 12.0781 6.14713 12.0781 5.83471 11.7657L2.63471 8.56569C2.32229 8.25327 2.32229 7.74673 2.63471 7.43431C2.94712 7.1219 3.45366 7.1219 3.76608 7.43431L6.40039 10.0686L12.2347 4.23431C12.5471 3.9219 13.0537 3.9219 13.3661 4.23431Z" fill="#00816B" />
                                                        </svg>
                                                        Credit card on file
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className={s.row}>
                                            <div className={s.col} style={{ width: '33%' }}>
                                                <div className={s.label}>First name</div>
                                                <div className={s.val}>
                                                    <Input value={targetClient.firstName} disabled />
                                                </div>
                                            </div>
                                            <div className={s.col} style={{ width: '33%' }}>
                                                <div className={s.label}>Last name</div>
                                                <div className={s.val}>
                                                    <Input value={targetClient.lastName} disabled />
                                                </div>
                                            </div>
                                            <div className={s.col} style={{ width: '33%' }}>
                                                <div className={s.label}>Preferred name</div>
                                                <div className={s.val}>
                                                    <Input value={targetClient.preferredName || '-'} disabled />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={s.row}>
                                            <div className={s.col} style={{ width: '100%' }}>
                                                <div className={s.label}>Reason for appointment</div>
                                                <div className={s.val}>
                                                    <TextArea
                                                        onChange={(e) => {
                                                            setReason(e.target.value);
                                                        }}
                                                        style={{ width: '100%' }}
                                                        value={reason}
                                                        autoSize={{ minRows: 2, maxRows: 6 }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            appointmentEventDetail?.relationship === 'self' ?
                                                <div className={s.row}>
                                                    <div className={s.col}>
                                                        <div className={s.label}>Book for someone else?</div>
                                                        <div className={s.val}>
                                                            false
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className={s.row}>
                                                    <div className={s.col} style={{ width: '54%' }}>
                                                        <div className={s.label}>Book for someone else?</div>
                                                        <div className={s.val}>
                                                            true
                                                        </div>
                                                    </div>
                                                    <div className={s.col} style={{ width: '54%' }}>
                                                        <div className={s.label}>Relationship to the client</div>
                                                        <div className={s.val}>
                                                            {appointmentEventDetail?.relationship || '-'}
                                                        </div>
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                )
                            }
                            <div className={s.vItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <DatePicker
                                    onChange={(val) => {
                                        setAppointmentDate(val || undefined);
                                    }}
                                    style={{ width: '250px' }}
                                    defaultValue={appointmentDate}
                                    format="dddd, MMM D, YYYY"
                                />
                            </div>
                            <div className={s.vItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <div className={s.timeSelectWrap}>
                                    <TimeSelect
                                        duration={targetService?.duration || 30}
                                        value={timeVal}
                                        minuteStep={15}
                                        onChange={handleTimeValChange}
                                    />
                                </div>
                                <div className={s.durationText}>
                                    {durationText}
                                </div>
                                {/* <InputNumber
                                    min={15}
                                    step={0}
                                    onChange={(val) => {
                                        const value = val || 0;
                                        setDuration(value);
                                        updateTimeValWithDurationChange(value);
                                    }}
                                    value={duration} style={{ width: '80px', marginLeft: '12px', marginRight: '8px' }}
                                /> */}
                                {/* mins */}
                            </div>
                            <div className={s.vItem} style={{ marginBottom: '12px' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M17.6569 16.6569C16.7202 17.5935 14.7616 19.5521 13.4138 20.8999C12.6327 21.681 11.3677 21.6814 10.5866 20.9003C9.26234 19.576 7.34159 17.6553 6.34315 16.6569C3.21895 13.5327 3.21895 8.46734 6.34315 5.34315C9.46734 2.21895 14.5327 2.21895 17.6569 5.34315C20.781 8.46734 20.781 13.5327 17.6569 16.6569Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <Select
                                    onChange={(val) => {
                                        setCurrentAppType(val);
                                    }}
                                    value={currentAppType}
                                    placeholder="Select a type"
                                    style={{ width: '200px' }}
                                >
                                    {
                                        optionType.map((item) => {
                                            return (
                                                <Select.Option value={item.value} key={item.value}>{item.label}</Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </div>
                            {
                                currentAppType === EContactTypeV2.VIDEO &&
                                <div className={s.itemUs}>
                                    <Input
                                        maxLength={150}
                                        value={meetingLink}
                                        onChange={(e) => {
                                            setMeetingLink(e.target.value);
                                        }}
                                        className={s.input}
                                        placeholder="Add a meeting link"
                                    />
                                </div>
                            }
                            {
                                currentAppType === EContactTypeV2.IN_PERSON &&
                                <div className={s.itemUs}>
                                    <Input
                                        maxLength={150}
                                        value={location}
                                        onChange={(e) => {
                                            setLocation(e.target.value);
                                        }}
                                        className={s.input}
                                        placeholder="Add location"
                                    />
                                </div>
                            }
                            {
                                currentAppType === EContactTypeV2.TELEPHONE &&
                                <div className={s.itemUs}>
                                    <USPhoneInput
                                        value={patientPhone}
                                        onChange={(val) => {
                                            setPatientPhone(val as string);
                                        }}
                                        className={s.input}
                                        placeholder="Add patient phone number"
                                    />
                                </div>
                            }
                            <div className={s.vItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M19 21.5V5.5C19 4.39543 18.1046 3.5 17 3.5H7C5.89543 3.5 5 4.39543 5 5.5V21.5M19 21.5L21 21.5M19 21.5H14M5 21.5L3 21.5M5 21.5H10M9 7.49998H10M9 11.5H10M14 7.49998H15M14 11.5H15M10 21.5V16.5C10 15.9477 10.4477 15.5 11 15.5H13C13.5523 15.5 14 15.9477 14 16.5V21.5M10 21.5H14" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <Select
                                    onChange={(val) => {
                                        setCurrentSpecialty(val);
                                    }}
                                    showSearch
                                    disabled={!isProviderScheduleEvent}
                                    value={currentSpecialty}
                                    placeholder="Select a specialty (optional)"
                                    style={{ width: '250px' }}
                                >
                                    {
                                        specialtiesOptions.map((item) => {
                                            return (
                                                <Select.Option value={item} key={item}>{item}</Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </div>
                            <div className={s.vItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M21 13.2554C18.2207 14.3805 15.1827 15 12 15C8.8173 15 5.7793 14.3805 3 13.2554M16 6V4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4V6M12 12H12.01M5 20H19C20.1046 20 21 19.1046 21 18V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <Select
                                    onChange={(val) => {
                                        setCurrentServiceType(val);
                                        if (!val) {
                                            return;
                                        }
                                        const target = serviceItems?.find((item) => item.serviceType === val);
                                        if (timeVal && timeVal.fromHour !== undefined && timeVal.fromMinute !== undefined && target && target.duration) {
                                            const endHour = Math.floor((timeVal.fromHour * 60 + timeVal.fromMinute + target.duration) / 60);
                                            const endMinute = (timeVal.fromHour * 60 + timeVal.fromMinute + target.duration) % 60;
                                            if (endHour > 23) {
                                                setTimeVal({
                                                    fromHour: timeVal.fromHour,
                                                    fromMinute: timeVal.fromMinute,
                                                    toHour: 23,
                                                    toMinute: 59,
                                                });
                                                updateDurationWithTimeVal({
                                                    fromHour: timeVal.fromHour,
                                                    fromMinute: timeVal.fromMinute,
                                                    toHour: 23,
                                                    toMinute: 59,
                                                });
                                                return;
                                            }
                                            setTimeVal({
                                                fromHour: timeVal.fromHour,
                                                fromMinute: timeVal.fromMinute,
                                                toHour: endHour,
                                                toMinute: endMinute,
                                            });
                                            updateDurationWithTimeVal({
                                                fromHour: timeVal.fromHour,
                                                fromMinute: timeVal.fromMinute,
                                                toHour: endHour,
                                                toMinute: endMinute,
                                            });
                                        }
                                    }}
                                    disabled={!isProviderScheduleEvent}
                                    value={currentServiceType}
                                    placeholder="Select service type"
                                    style={{ width: '250px' }}
                                >
                                    {
                                        optionServiceType.map((item) => {
                                            return (
                                                <Select.Option value={item.value} key={item.value}>{item.label}</Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                                {
                                    isProviderScheduleEvent &&
                                    <span
                                        onClick={() => {
                                            setCurrentServiceType(undefined);
                                        }}
                                        className={s.removeType}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <path d="M6 18.5L18 6.5M6 6.5L18 18.5" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                }
                            </div>
                        </div>
                    </div>
                }

                {
                    showEditBlockTimeView &&
                    <div className={s.view}>
                        <div className={s.top}>
                            <div />
                            <div className={s.btnWrap}>
                                <span
                                    onClick={handleRemove}
                                    className={s.btn}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7M10 11V17M14 11V17M15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7M4 7H20" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <span
                                    onClick={() => {
                                        setIsViewOnly(false);
                                    }}
                                    className={s.btn}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M20.2677 3.73223L20.9748 3.02513V3.02513L20.2677 3.73223ZM6.5 21.0355V22.0355C6.76522 22.0355 7.01957 21.9301 7.20711 21.7426L6.5 21.0355ZM3 21.0355H2C2 21.5878 2.44772 22.0355 3 22.0355V21.0355ZM3 17.4644L2.29289 16.7573C2.10536 16.9448 2 17.1992 2 17.4644H3ZM17.4393 4.43934C18.0251 3.85355 18.9748 3.85355 19.5606 4.43934L20.9748 3.02513C19.608 1.65829 17.3919 1.65829 16.0251 3.02513L17.4393 4.43934ZM19.5606 4.43934C20.1464 5.02513 20.1464 5.97487 19.5606 6.56066L20.9748 7.97487C22.3417 6.60804 22.3417 4.39196 20.9748 3.02513L19.5606 4.43934ZM19.5606 6.56066L5.79289 20.3284L7.20711 21.7426L20.9748 7.97487L19.5606 6.56066ZM6.5 20.0355H3V22.0355H6.5V20.0355ZM16.0251 3.02513L2.29289 16.7573L3.70711 18.1715L17.4393 4.43934L16.0251 3.02513ZM2 17.4644V21.0355H4V17.4644H2ZM14.5251 5.93934L18.0606 9.47487L19.4748 8.06066L15.9393 4.52513L14.5251 5.93934Z" fill="#6B7280" />
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div className={s.viewContent}>
                            <div className={s.vTitle}>
                                {/* Appointment name: [Specialty icon] Patient name - [State] Specialty: Visit type */}
                                <span className={s.vTagBlock} />
                                <div className={s.vtVal}>
                                    <img src="" alt="" />
                                    {blockTimeTitle}
                                </div>
                            </div>
                            <div className={s.vItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                {blockerViewDateLabel}
                            </div>
                            <div className={s.vItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                {blockerViewTimeLabel}
                                {' '}
                                ({myTimezone.value})
                                {' | '}
                                {duration}
                                {' mins'}
                            </div>
                            {
                                declineAll &&
                                <div className={s.vItem}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604M18.364 18.364C14.8492 21.8787 9.15076 21.8787 5.63604 18.364C2.12132 14.8492 2.12132 9.15076 5.63604 5.63604M18.364 18.364L5.63604 5.63604" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Decline all existing appointments
                                </div>
                            }
                            {
                                !blockEventDetail?.isAllDay &&
                                <div className={s.vItem}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M4 4V9H4.58152M19.9381 11C19.446 7.05369 16.0796 4 12 4C8.64262 4 5.76829 6.06817 4.58152 9M4.58152 9H9M20 20V15H19.4185M19.4185 15C18.2317 17.9318 15.3574 20 12 20C7.92038 20 4.55399 16.9463 4.06189 13M19.4185 15H15" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {repeatText}
                                </div>
                            }
                        </div>
                    </div>
                }

                {
                    showEditBlockTimeForm &&
                    <div className={s.view}>
                        <div className={s.top}>
                            <div />
                            <div className={s.btnWrap}>
                                <Button
                                    onClick={() => {
                                        setIsViewOnly(true);
                                        updateUiWithBlockerEventDetail(blockEventDetail);
                                    }}
                                    className={s.btn}
                                >
                                    Discard
                                </Button>
                                <Button
                                    onClick={onOk}
                                    loading={submiting}
                                    className={s.btn}
                                    type="primary"
                                >
                                    Save
                                </Button>
                            </div>
                        </div>
                        <div className={s.viewContent}>
                            <div className={s.vItem}>
                                <Input
                                    style={{ width: '90%' }}
                                    value={blockTimeTitle}
                                    onChange={(e) => {
                                        setBlockTimeTitle(e.target.value);
                                    }}
                                />
                            </div>
                            <div className={s.vItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                {
                                    !allDay &&
                                    <DatePicker
                                        onChange={(val) => {
                                            setBlockDayStart(val || undefined);
                                        }}
                                        style={{ width: '250px' }}
                                        value={blockDayStart}
                                        format="dddd, MMM D, YYYY"
                                    />
                                }
                                {
                                    allDay &&
                                    <DatePicker.RangePicker
                                        value={[blockDayStart || null, blockDayEnd || null]}
                                        onChange={(val) => {
                                            setBlockDayStart(val?.[0] || undefined);
                                            setBlockDayEnd(val?.[1] || undefined);
                                        }}
                                    />
                                }
                            </div>
                            <div className={s.vItem}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <div className={s.timeSelectWrap}>
                                    <TimeSelect
                                        value={timeVal}
                                        minuteStep={15}
                                        onChange={handleTimeValChange}
                                    />
                                </div>
                                <div className={s.durationText}>
                                    {durationText}
                                </div>
                                {/* <InputNumber
                                    step={15}
                                    onChange={(val) => {
                                        const value = val || 0;
                                        setDuration(value);
                                        updateTimeValWithDurationChange(value);
                                    }}
                                    min={15}
                                    value={duration}
                                    style={{ width: '80px', marginLeft: '12px', marginRight: '8px' }}
                                /> */}
                                {/* mins */}
                            </div>
                            <div className={s.vItem}>
                                <Checkbox
                                    onChange={(e) => {
                                        setAllDay(e.target.checked);
                                    }}
                                    checked={allDay}
                                    style={{ marginLeft: '4px' }}
                                >
                                    All day
                                </Checkbox>
                            </div>
                            {
                                !allDay &&
                                <div className={s.vItem}>
                                    <Select
                                        onChange={(val) => {
                                            setRepeatType(val);
                                        }}
                                        value={repeatType}
                                        placeholder="Select service type"
                                        style={{ width: '300px' }}
                                    >
                                        {
                                            optionsRepeat.map((item) => {
                                                return (
                                                    <Select.Option value={item.value}>{item.label}</Select.Option>
                                                );
                                            })
                                        }
                                    </Select>
                                </div>
                            }
                            <div className={s.vItem}>
                                <Checkbox
                                    onChange={(e) => {
                                        setDeclineAll(e.target.checked);
                                    }}
                                    checked={declineAll}
                                    style={{ marginLeft: '4px' }}
                                >
                                    Decline all existing appointments
                                </Checkbox>
                            </div>
                        </div>
                    </div>
                }
            </div>
            {!isEdit && (
                <div className={s.footer}>
                    <div style={{ paddingRight: '20px' }}>
                        <Button onClick={onCancel}>Cancel</Button>
                        <Button loading={submiting} type="primary" onClick={onOk}>Save</Button>
                    </div>
                </div>
            )}
            {/* {
                isEdit && showEditAppointmentView && !isCanceled && !isGoogleEvent && canChangeStatus && (
                    <div className={s.footer}>
                        <div>
                            <Button type='text'
                                onClick={() => {
                                    setShowConfirmCancelModal(true)
                                }}
                                className={s.lightBtn}>Cancel appointment</Button>
                        </div>
                    </div>
                )
            } */}

            <Modal
                open={showConfirmChangeNoteModal}
                title="Confirm appointment changes"
                width={660}
                okText="Save"
                className={commonS.modalFixHeightWrap}
                onCancel={() => {
                    setShowConfirmChangeNoteModal(false);
                }}
                onOk={handleConfirmChange}
                okButtonProps={{
                    loading: submiting,
                }}
            >
                <div className={s.cWrap}>
                    <div className={s.cLabel}>
                        You’ve made changes to the appointment. Please review the updated details below:
                    </div>
                    <div className={s.cPreview}>
                        {
                            hasModifiedDateAndTime &&
                            <>
                                <div className={s.cPreviewItemOrg}>
                                    <div className={s.cPreviewLabel}>{modifiedDateAndTimeTextLabelOrg}:</div>
                                    <div className={s.cPreviewVal}>{modifiedDateAndTimeTextOrg}</div>
                                </div>
                                <div className={s.cPreviewItemNew}>
                                    <div className={s.cPreviewLabel}>{modifiedDateAndTimeTextLabelNew}:</div>
                                    <div className={s.cPreviewVal}>{modifiedDateAndTimeTextNew}</div>
                                </div>
                            </>
                        }
                        {
                            hasModifiedAppType &&
                            <>
                                <div className={s.cPreviewItemOrg}>
                                    <div className={s.cPreviewLabel}>{modifiedAppTypeTextLabelOrg}:</div>
                                    <div className={s.cPreviewVal}>{modifiedAppTypeTextOrg}</div>
                                </div>
                                <div className={s.cPreviewItemNew}>
                                    <div className={s.cPreviewLabel}>{modifiedAppTypeTextLabelNew}:</div>
                                    <div className={s.cPreviewVal}>{modifiedAppTypeTextNew}</div>
                                </div>
                            </>
                        }
                        {
                            !hasModifiedAppType && (hasModifiedMeetingLink || hasModifiedLocation) &&
                            <div className={s.cPreviewItemNew}>
                                <div className={s.cPreviewLabel}>{modifiedMeetingLinkOrLocationOrPhoneLabelNew}:</div>
                                <div className={s.cPreviewVal}>{modifiedMeetingLinkOrLocationOrPhoneTextNew}</div>
                            </div>
                        }

                    </div>
                    <div className={s.msgToWrap}>
                        <div className={s.mtTitle}>Message to patient</div>
                        <div className={s.mtContent}>
                            <div className={s.mtHeader}>
                                Dear {targetClient?.firstName},
                            </div>
                            <div className={s.mtDes}>
                                {emailChangeDes1}
                            </div>
                            <div className={s.mtDes}>
                                <div className={s.org}>
                                    <div className={s.mtDesLabel}>{emailChangeDes2Line1Label}</div>
                                    <div className={s.mtDesVal}>{emailChangeDes2Line1Value}</div>
                                </div>
                                <div className={s.new}>
                                    <div className={s.mtDesLabel}>{emailChangeDes2Line2Label}</div>
                                    <div className={s.mtDesVal}>{emailChangeDes2Line2Value}</div>
                                </div>
                                <div className={s.org}>
                                    <div className={s.mtDesLabel}>{emailChangeDes2Line3Label}</div>
                                    <div className={s.mtDesVal}>{emailChangeDes2Line3Value}</div>
                                </div>
                                <div className={s.new}>
                                    <div className={s.mtDesLabel}>{emailChangeDes2Line4Label}</div>
                                    <div className={s.mtDesVal}>{emailChangeDes2Line4Value}</div>
                                </div>
                            </div>
                            <div className={s.mtDes}>{emailChangeDes3}</div>
                            {
                                showExtraInput && (
                                    <div className={s.mtCus}>
                                        <div className={s.mtCusTitle}>
                                            Customized message to patient <span style={{ color: '#8E8E8E' }}>(optional)</span>
                                        </div>
                                        <div className={s.mtCusValue}>
                                            <Input.TextArea
                                                onChange={(e) => {
                                                    setChangeCustomizeText(e.target.value);
                                                }}
                                                value={changeCustomizeText}
                                                onKeyDown={(e) => {
                                                }}
                                                placeholder="Add customized message..."
                                                rows={4}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                            <div className={s.mtFooter}>
                                <p>Looking forward to our visit,</p>
                                <p>
                                    {getProviderNameDisplay(getUser('data') as any)} {getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showConfirmRemoveAppointmentModal}
                title={null}
                width={660}
                okText="Delete"
                okButtonProps={{
                    loading: deleting,
                }}
                onCancel={() => {
                    setShowConfirmRemoveAppointmentModal(false);
                }}
                footer={null}
            >
                <div className={s.rWrapOut}>
                    <div className={s.rWrap}>
                        <div className={s.rLabel}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className={s.rContent}>
                            <div className={s.rTitle}>Delete this appointment?</div>
                            <div className={s.rDes}>Are you sure you want to delete this appointment? The appointment will be canceled and removed from your calendar; the action can’t be undone.</div>
                        </div>
                    </div>
                    <div className={s.rBtn}>
                        <Button
                            style={{
                                marginRight: '16px',
                            }}
                            onClick={() => {
                                setShowConfirmRemoveAppointmentModal(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            danger
                            type="primary"
                            loading={deleting}
                            onClick={() => {
                                handleConfirmRemove();
                            }}
                            className={s.deleteBtn}
                        >Delete
                        </Button>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showConfirmRemoveBlockerModal}
                title={null}
                width={660}
                okText="Delete"
                onCancel={() => {
                    setShowConfirmRemoveBlockerModal(false);
                }}
                okButtonProps={{
                    loading: deleting,
                }}
                footer={null}
            >
                <div className={s.rWrapOut}>
                    <div className={s.rWrap}>
                        <div className={s.rLabel}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className={s.rContent}>
                            <div className={s.rTitle}>Delete this block time?</div>
                            <div className={s.rDes}>Are you sure you want to delete this block time? The block time will be removed from your calendar; the action can’t be undone.</div>
                        </div>
                    </div>
                    <div className={s.rBtn}>
                        <Button
                            style={{
                                marginRight: '16px',
                            }}
                            onClick={() => {
                                setShowConfirmRemoveBlockerModal(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            danger
                            type="primary"
                            loading={deleting}
                            onClick={() => {
                                handleConfirmRemove();
                            }}
                            className={s.deleteBtn}
                        >Delete
                        </Button>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showConfirmPatientCancelModal}
                title="Patient cancel appointment"
                width={660}
                okText="Delete"
                onCancel={() => {
                    setCancelReason(undefined);
                    setShowConfirmPatientCancelModal(false);
                }}
                className={commonS.modalFixHeightWrap}
                footer={(
                    <div className={s.cancelBtn}>
                        <Button
                            onClick={() => {
                                setCancelReason(undefined);
                                setShowConfirmPatientCancelModal(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={!canCancelAppointment}
                            onClick={() => {
                                handleConfirmPatientCancel();
                            }}
                            loading={updatingScheduleType}
                            type="primary"
                            className={s.deleteBtn}
                        >Cancel appointment
                        </Button>
                    </div>
                )}
            >
                <div className={s.cancelWrapOut}>
                    <div className={s.cancelWrap}>
                        <div className={s.cancelTitle}>
                            Please select a reason for canceling this appointment. You could also include a brief custom message for the patient.
                        </div>
                        <div className={s.cancelReason}>
                            <Radio.Group
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 8,
                                }}
                                onChange={(e) => {
                                    setCancelReason(e.target.value);
                                }}
                                value={cancelReason}
                                options={optionPatientCancelReason}
                            />
                        </div>
                        {
                            cancelReason === EPatientCancelReasonLabel.OTHER_REASONS &&
                            <div className={s.otherReason}>
                                {/* <Radio.Group
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 8,
                                    }}
                                    onChange={(e) => {
                                        setCancelReasonSub(e.target.value);
                                    }}
                                    value={cancelReasonSub}
                                    options={[
                                        {
                                            label: 'Incomplete Patient Information',
                                            value: 'Incomplete Patient Information',
                                        },
                                        {
                                            label: 'Patient Behavior Concerns',
                                            value: 'Patient Behavior Concerns',
                                        },
                                        {
                                            label: 'Public Health or Emergency Situations',
                                            value: 'Public Health or Emergency Situations',
                                        }
                                    ]}
                                /> */}
                                <TextArea
                                    onChange={(e) => {
                                        setCancelReasonOther(e.target.value);
                                    }}
                                    className={s.otherInput}
                                    value={cancelReasonOther}
                                    rows={4}
                                    maxLength={2000}
                                    placeholder="Specify your reason for canceling this appointment..."
                                />
                            </div>
                        }
                        <div className={s.msgToWrap}>
                            <div className={s.mtTitle}>Message to patient</div>
                            <div className={s.mtContent}>
                                <div className={s.mtHeader}>
                                    Dear {targetClient?.firstName},
                                </div>
                                <div className={s.mtDes}>
                                    You have initiated cancellation to our scheduled appointment on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span>.
                                    I'm here to acknowledge your cancellation and sincerely hope you feel well soon.
                                </div>
                                <div className={s.mtCus}>
                                    <div className={s.mtCusTitle}>
                                        Customized message to patient <span style={{ color: '#8E8E8E' }}>(optional)</span>
                                    </div>
                                    <div className={s.mtCusValue}>
                                        <Input.TextArea
                                            onChange={(e) => {
                                                setCustomizeText(e.target.value);
                                            }}
                                            ref={textAreaRef}
                                            value={customizeText}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Tab' && !customizeText) {
                                                    e.preventDefault(); // 防止默认的Tab行为（切换焦点）
                                                    setCustomizeText('Please reach out to me so we can find a new time that works for you.');
                                                }
                                            }}
                                            rows={4}
                                        />
                                        {
                                            !customizeText &&
                                            <div
                                                onClick={() => {
                                                    textAreaRef?.current?.focus();
                                                }}
                                                className={s.placeHolder}
                                            >
                                                Please reach out to me so we can find a new time that works for you.
                                                <span className={s.placeHolderText}>Press “Tab” to use the text</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className={s.mtFooter}>
                                    <p>Best regards,</p>
                                    <p className={s.mSign}>Email signature</p>
                                    <p>
                                        <Input
                                            value={emailSign}
                                            onChange={(e) => {
                                                setEmailSign(e.target.value);
                                            }}
                                            placeholder={`${getProviderNameDisplay(getUser('data') as any)}${getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''}`}
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showConfirmPatientNoShowOrLateCancelNoProtectModal}
                title={null}
                width={550}
                onCancel={() => {
                    setScheduleStatus(EScheduleStatusValue.SCHEDULED);
                    setShowConfirmPatientNoShowOrLateCancelNoProtectModal(false);
                    setCancelReasonForLateCancel(undefined);
                }}
                footer={null}
            >
                <div className={s.rWrapOut}>
                    <div className={s.rWrap}>
                        <div className={s.rLabel2}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M8.22766 9C8.77678 7.83481 10.2584 7 12.0001 7C14.2092 7 16.0001 8.34315 16.0001 10C16.0001 11.3994 14.7224 12.5751 12.9943 12.9066C12.4519 13.0106 12.0001 13.4477 12.0001 14M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#0284C7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className={s.rContent}>
                            <div className={s.rTitle}>Unable to charge patient for “{changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_NO_SHOW ? 'No-show' : 'Late canceled'}” fee</div>
                            <div className={s.rDes}>You won’t be able to charge {targetClient?.firstName} {targetClient?.lastName} a {changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_NO_SHOW ? 'no-show' : 'late canceled'} fee because they don’t have a credit card on file.</div>
                            {
                                changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_LATE_CANCELED &&
                                <div className={s.rReason}>
                                    <div className={s.rReasonLabel}>Add a reason for cancellation to keep better records and understand patient behavior.</div>
                                    <Input.TextArea
                                        rows={4}
                                        maxLength={2000}
                                        placeholder="Add reason for cancellation (optional) ..."
                                        value={cancelReasonForLateCancel}
                                        onChange={(e) => {
                                            setCancelReasonForLateCancel(e.target.value);
                                        }}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    {
                        canSendPatientPortalLink &&
                        <div className={s.rBtn}>
                            <Button
                                loading={updatingScheduleType}
                                style={{
                                    marginRight: '16px',
                                }}
                                onClick={() => {
                                    handleScheduleTypeChange(EScheduleStatusValue.SCHEDULED, changeToPatientNoShowOrLateCancelRef.current?.status);
                                    setShowConfirmPatientNoShowOrLateCancelNoProtectModal(false);
                                }}
                            >
                                {`Mark as "${changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_NO_SHOW ? 'No show' : 'Late canceled'}"`}
                            </Button>

                            <Button
                                type="primary"
                                disabled={hasClickSendPatientPortalInvitation}
                                loading={sendingInvitation}
                                onClick={() => {
                                    handleClickSendInvitation(`${eventClient?.id}`);
                                }}
                            >
                                Send patient portal invitation
                            </Button>

                        </div>
                    }
                    {
                        !canSendPatientPortalLink &&
                        <div className={s.rBtn}>
                            <Button
                                style={{
                                    marginRight: '16px',
                                }}
                                onClick={() => {
                                    setScheduleStatus(EScheduleStatusValue.SCHEDULED);
                                    setShowConfirmPatientNoShowOrLateCancelNoProtectModal(false);
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                loading={updatingScheduleType}
                                onClick={() => {
                                    handleScheduleTypeChange(EScheduleStatusValue.SCHEDULED, changeToPatientNoShowOrLateCancelRef.current?.status);
                                    setShowConfirmPatientNoShowOrLateCancelNoProtectModal(false);
                                }}
                            >
                                {`Mark as "${changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_NO_SHOW ? 'No show' : 'Late canceled'}"`}
                            </Button>
                        </div>
                    }
                </div>
            </Modal>

            <Modal
                open={showConfirmPatientNoShowOrLateCancelProtectModal}
                title={null}
                width={550}
                onCancel={() => {
                    setShowWaiveFeeMessage(false);
                    setShowChargeFeeMessage(false);
                    setScheduleStatus(EScheduleStatusValue.SCHEDULED);
                    setShowConfirmPatientNoShowOrLateCancelProtectModal(false);
                }}
                style={{ opacity: showCannotChargeIn24HourModal ? 0 : 1 }}
                className={commonS.modalFixHeightWrap}
                footer={
                    <>
                        {
                            (showChargeFeeMessage || showWaiveFeeMessage) && (
                                <div className={s.rBtn}>
                                    <Button
                                        style={{
                                            marginRight: '8px',
                                        }}
                                        loading={deleting}
                                        onClick={() => {
                                            setShowWaiveFeeMessage(false);
                                            setShowChargeFeeMessage(false);
                                        }}
                                    >
                                        Back
                                    </Button>
                                    <Button
                                        type="primary"
                                        loading={updatingScheduleType}
                                        onClick={() => {
                                            handleScheduleTypeChange(EScheduleStatusValue.SCHEDULED, changeToPatientNoShowOrLateCancelRef.current?.status || EScheduleStatusValue.SCHEDULED);
                                        }}
                                    >
                                        Confirm
                                    </Button>
                                </div>
                            )

                        }
                        {
                            !showChargeFeeMessage && !showWaiveFeeMessage && (
                                <div className={s.rBtn} style={{ marginTop: 0 }}>
                                    <Button
                                        style={{
                                            marginRight: '8px',
                                        }}
                                        loading={deleting}
                                        onClick={() => {
                                            if (chargeIn24Hour && changeToPatientNoShowOrLateCancelRef?.current?.status === EScheduleStatusValue.PATIENT_LATE_CANCELED) {
                                                setShowCannotChargeIn24HourModal(true);
                                                return;
                                            }
                                            if (changeToPatientNoShowOrLateCancelRef.current) {
                                                changeToPatientNoShowOrLateCancelRef.current.chargeFee = true;
                                            }
                                            setShowChargeFeeMessage(true);
                                        }}
                                    >
                                        Charge fee
                                    </Button>
                                    <Button
                                        type="primary"
                                        onClick={() => {
                                            if (changeToPatientNoShowOrLateCancelRef.current) {
                                                changeToPatientNoShowOrLateCancelRef.current.chargeFee = false;
                                            }
                                            setShowWaiveFeeMessage(true);
                                        }}
                                    >
                                        Waive fee
                                    </Button>
                                </div>
                            )
                        }
                    </>
                }
            >
                <div className={s.rWrapOut}>
                    <div className={s.rWrap}>
                        <div className={s.rLabel2}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M8.22766 9C8.77678 7.83481 10.2584 7 12.0001 7C14.2092 7 16.0001 8.34315 16.0001 10C16.0001 11.3994 14.7224 12.5751 12.9943 12.9066C12.4519 13.0106 12.0001 13.4477 12.0001 14M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#0284C7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className={s.rContent}>
                            <div className={s.rTitle}>{chargerFeeTitle}</div>
                            {
                                showWaiveFeeMessage &&
                                <div className={s.rDes}>
                                    You've waived the {statusLabel?.toLowerCase()} fee for {targetClient?.firstName} {targetClient?.lastName}. Use the message below to let them know you're here to help them reschedule when they’re ready.
                                </div>
                            }
                            {
                                showChargeFeeMessage &&
                                <div className={s.rDes}>
                                    You’ve applied a {statusLabel?.toLowerCase()} fee based on your billing policy for {targetClient?.firstName} {targetClient?.lastName}. Use the message below to inform the patient.
                                </div>
                            }
                            {
                                !showWaiveFeeMessage && !showChargeFeeMessage &&
                                <>
                                    <div className={s.rDes}>
                                        Do you want to charge {targetClient?.firstName} {targetClient?.lastName}  a ${chargeFee} fee for this {changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_NO_SHOW ? 'no-show' : 'late canceled'} based on your billing policy?
                                    </div>
                                    <div className={s.rNote}>
                                        <div className={s.rNoteTitle}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M8.25803 3.09858C9.02264 1.73928 10.9797 1.73928 11.7443 3.09858L17.3246 13.0191C18.0746 14.3523 17.1111 15.9996 15.5815 15.9996H4.42088C2.89123 15.9996 1.9278 14.3523 2.67773 13.0191L8.25803 3.09858ZM11.0011 12.9998C11.0011 13.552 10.5534 13.9998 10.0011 13.9998C9.44881 13.9998 9.0011 13.552 9.0011 12.9998C9.0011 12.4475 9.44881 11.9998 10.0011 11.9998C10.5534 11.9998 11.0011 12.4475 11.0011 12.9998ZM10.0011 4.99976C9.44881 4.99976 9.0011 5.44747 9.0011 5.99976V8.99976C9.0011 9.55204 9.44881 9.99976 10.0011 9.99976C10.5534 9.99976 11.0011 9.55204 11.0011 8.99976V5.99976C11.0011 5.44747 10.5534 4.99976 10.0011 4.99976Z" fill="#FBBF24" />
                                            </svg>
                                            Important notice
                                        </div>
                                        <div className={s.rNoteDes}>
                                            If you apply a penalty, the patient may contact Klarity to seek alternative care. Waiving the fee allows you to rebook this patient in the future — applying a fee may reduce the likelihood of them returning.
                                        </div>
                                    </div>
                                </>
                            }

                            {
                                changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_NO_SHOW && showWaiveFeeMessage && (
                                    <div className={s.msgToWrap}>
                                        <div className={s.mtTitle}>Message to patient</div>
                                        <div className={s.mtContent}>
                                            <div className={s.mtHeader}>
                                                Dear {targetClient?.firstName},
                                            </div>
                                            <div className={s.mtDes}>
                                                I noticed you didn’t show up for our {currentServiceType} scheduled on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span>.  I understand that unexpected situations can arise, and I hope everything is okay.
                                                <br />
                                                <br />
                                                I'd love to help you reschedule when you're ready. Please feel free to book another appointment at your convenience — I'm here to support your health journey.
                                            </div>
                                            <div className={s.mtCus}>
                                                <div className={s.mtCusTitle}>
                                                    Customized message to patient <span style={{ color: '#8E8E8E' }}>(optional)</span>
                                                </div>
                                                <div className={s.mtCusValue}>
                                                    <Input.TextArea
                                                        onChange={(e) => {
                                                            setCustomizeText(e.target.value);
                                                        }}
                                                        ref={textAreaRef}
                                                        value={customizeText}
                                                        rows={4}
                                                        placeholder="Add customized message..."
                                                    />
                                                </div>
                                            </div>
                                            <div className={s.mtFooter}>
                                                <p>Best regards,</p>
                                                <p className={s.mSign}>Email signature</p>
                                                <p>
                                                    <Input
                                                        value={emailSign}
                                                        onChange={(e) => {
                                                            setEmailSign(e.target.value);
                                                        }}
                                                        placeholder={`${getProviderNameDisplay(getUser('data') as any)}${getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''}`}
                                                    />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_NO_SHOW && showChargeFeeMessage && (
                                    <div className={s.msgToWrap}>
                                        <div className={s.mtTitle}>Message to patient</div>
                                        <div className={s.mtContent}>
                                            <div className={s.mtHeader}>
                                                Dear {targetClient?.firstName},
                                            </div>
                                            <div className={s.mtDes}>
                                                I noticed you didn’t show up for our {currentServiceType} scheduled on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span>.I’ve marked the appointment as a no-show in the system.
                                                <br />
                                                <br />
                                                As a reminder, a no-show fee applies based on my practice’s billing policy. See below for details.
                                            </div>
                                            <div className={s.mtCus}>
                                                <div className={s.mtCusTitle}>
                                                    Customized message to patient <span style={{ color: '#8E8E8E' }}>(optional)</span>
                                                </div>
                                                <div className={s.mtCusValue}>
                                                    <Input.TextArea
                                                        onChange={(e) => {
                                                            setCustomizeText(e.target.value);
                                                        }}
                                                        ref={textAreaRef}
                                                        value={customizeText}
                                                        rows={4}
                                                        placeholder="Add customized message..."
                                                    />
                                                </div>
                                            </div>
                                            <div className={s.mtFooter}>
                                                <p>Best regards,</p>
                                                <p className={s.mSign}>Email signature</p>
                                                <p>
                                                    <Input
                                                        value={emailSign}
                                                        onChange={(e) => {
                                                            setEmailSign(e.target.value);
                                                        }}
                                                        placeholder={`${getProviderNameDisplay(getUser('data') as any)}${getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''}`}
                                                    />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }

                            {
                                changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_LATE_CANCELED && showWaiveFeeMessage && (
                                    <div className={s.msgToWrap}>
                                        <div className={s.mtTitle}>Message to patient</div>
                                        <div className={s.mtContent}>
                                            <div className={s.mtHeader}>
                                                Dear {targetClient?.firstName},
                                            </div>
                                            <div className={s.mtDes}>
                                                I saw that you had to cancel our {currentServiceType} appointment on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span> at short notice. I completely understand that things can come up, and I hope you're doing well.
                                                <br />
                                                <br />
                                                I'd love to help you reschedule when you're ready. Please feel free to book another appointment at your convenience — I'm here to support your health journey.
                                            </div>
                                            <div className={s.mtCus}>
                                                <div className={s.mtCusTitle}>
                                                    Customized message to patient <span style={{ color: '#8E8E8E' }}>(optional)</span>
                                                </div>
                                                <div className={s.mtCusValue}>
                                                    <Input.TextArea
                                                        onChange={(e) => {
                                                            setCustomizeText(e.target.value);
                                                        }}
                                                        ref={textAreaRef}
                                                        value={customizeText}
                                                        rows={4}
                                                        placeholder="Add customized message..."
                                                    />
                                                </div>
                                            </div>
                                            <div className={s.mtFooter}>
                                                <p>Best regards,</p>
                                                <p className={s.mSign}>Email signature</p>
                                                <p>
                                                    <Input
                                                        value={emailSign}
                                                        onChange={(e) => {
                                                            setEmailSign(e.target.value);
                                                        }}
                                                        placeholder={`${getProviderNameDisplay(getUser('data') as any)}${getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''}`}
                                                    />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }

                            {
                                changeToPatientNoShowOrLateCancelRef.current?.status === EScheduleStatusValue.PATIENT_LATE_CANCELED && showChargeFeeMessage && (
                                    <div className={s.msgToWrap}>
                                        <div className={s.mtTitle}>Message to patient</div>
                                        <div className={s.mtContent}>
                                            <div className={s.mtHeader}>
                                                Dear {targetClient?.firstName},
                                            </div>
                                            <div className={s.mtDes}>
                                                I noticed you canceled our {currentServiceType} appointment on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span> with short notice. I’ve marked the appointment as a late cancellation in the system.
                                                <br />
                                                <br />
                                                As a reminder, a late cancellation fee applies based on my billing policy. Below are the details for your reference.
                                            </div>
                                            <div className={s.mtCus}>
                                                <div className={s.mtCusTitle}>
                                                    Customized message to patient <span style={{ color: '#8E8E8E' }}>(optional)</span>
                                                </div>
                                                <div className={s.mtCusValue}>
                                                    <Input.TextArea
                                                        onChange={(e) => {
                                                            setCustomizeText(e.target.value);
                                                        }}
                                                        ref={textAreaRef}
                                                        value={customizeText}
                                                        rows={4}
                                                        placeholder="Add reason for cancellation ..."
                                                    />
                                                </div>
                                            </div>
                                            <div className={s.mtFooter}>
                                                <p>Best regards,</p>
                                                <p className={s.mSign}>Email signature</p>
                                                <p>
                                                    <Input
                                                        value={emailSign}
                                                        onChange={(e) => {
                                                            setEmailSign(e.target.value);
                                                        }}
                                                        placeholder={`${getProviderNameDisplay(getUser('data') as any)}${getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''}`}
                                                    />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showConfirmShowModal}
                title="Stay connected — set up a follow-up visit"
                width={660}
                className={commonS.modalFixHeightWrap}
                onCancel={() => {
                    //close do nothing
                    setShowConfirmShowModal(false);
                    setScheduleStatus(EScheduleStatusValue.SCHEDULED);
                }}
                footer={
                    <div className={s.cancelBtn}>
                        <Button
                            onClick={() => {
                                changeToShowActionRef.current = 'skip';
                                handleScheduleTypeChange(EScheduleStatusValue.SCHEDULED, EScheduleStatusValue.SHOWED, false, 'Follow-up skipped. No action will be taken.');
                            }}
                            loading={updatingScheduleType && changeToShowActionRef.current === 'skip'}
                        >
                            Skip
                        </Button>
                        <Button
                            onClick={() => {
                                //do update
                                changeToShowActionRef.current = 'confirm';
                                handleScheduleTypeChange(EScheduleStatusValue.SCHEDULED, EScheduleStatusValue.SHOWED, false, 'Your follow-up selection has been saved.');
                            }}
                            disabled={changeToShowDisabled || !canFollowUp}
                            loading={updatingScheduleType && changeToShowActionRef.current === 'confirm'}
                            type="primary"
                        >Confirm
                        </Button>
                    </div>
                }
            >
                <div className={s.showWrapOut}>
                    <div className={s.mText}>
                        Proactive follow-up helps patients stay engaged with your practice. Choose how you'd like to continue care.
                    </div>
                    <div className={s.mNote}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z" fill="#60A5FA" />
                        </svg>
                        Our data shows that providers who schedule follow-ups have 35% higher patient retention rates.
                    </div>
                    <div className={`${s.itemWrap} ${selectScheduleItemIndex === 2 ? s.itemWrapSelect2 : ''}`}>
                        <div
                            onClick={() => {
                                setSelectScheduleItemIndex(1);
                            }}
                            className={`${s.mScheduleItem} ${selectScheduleItemIndex === 1 ? s.mScheduleItemSelect : ''}`}
                        >
                            <div className={s.mScheduleItemTitle}>
                                <div className={s.mScheduleItemTitleLeft}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M8 10H8.01M12 10H12.01M16 10H16.01M9 16H5C3.89543 16 3 15.1046 3 14V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V14C21 15.1046 20.1046 16 19 16H14L9 21V16Z" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Schedule a smart follow-up
                                </div>
                                <div className={s.mScheduleItemTitleRight}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.9984 21.5999C17.3004 21.5999 21.5984 17.3018 21.5984 11.9999C21.5984 6.69797 17.3004 2.3999 11.9984 2.3999C6.6965 2.3999 2.39844 6.69797 2.39844 11.9999C2.39844 17.3018 6.6965 21.5999 11.9984 21.5999ZM16.447 10.4484C16.9156 9.9798 16.9156 9.22 16.447 8.75137C15.9783 8.28275 15.2185 8.28275 14.7499 8.75137L10.7984 12.7028L9.24696 11.1514C8.77833 10.6827 8.01854 10.6827 7.54991 11.1514C7.08128 11.62 7.08128 12.3798 7.54991 12.8484L9.94991 15.2484C10.4185 15.7171 11.1783 15.7171 11.647 15.2484L16.447 10.4484Z" fill="#00816B" />
                                    </svg>
                                </div>
                            </div>
                            <div className={s.mScheduleItemDes}>
                                Set a time now — the system will help you schedule a follow-up appointment with the patient.
                            </div>
                            {/* <div className={s.mScheduleItemContent}>
                                <div className={s.mScheduleItemContentDay}>
                                    <div className={s.mLabel}>Date:</div>
                                    <div className={s.mValue}>
                                        <InputNumber
                                            step={1}
                                            type="number"
                                            value={scheduleSmartFollowUpValue}
                                            maxLength={3}
                                            className={s.input}
                                            status={scheduleSmartFollowUpValueError ? 'error' : undefined}
                                            onChange={(e) => {
                                                if (!e && e !== 0) {
                                                    setScheduleSmartFollowUpValue(undefined);
                                                    return;
                                                }
                                                const text = (`${e}`).replace(/\D/g, '');
                                                if (text) {
                                                    const valNum = parseInt(text);
                                                    if (Number.isNaN(valNum)) {
                                                        setScheduleSmartFollowUpValue(undefined);
                                                        return;
                                                    }
                                                    setScheduleSmartFollowUpValue(valNum);
                                                } else {
                                                    setScheduleSmartFollowUpValue(undefined);
                                                }
                                            }}
                                        />
                                        <div className={s.inputError}>
                                            {scheduleSmartFollowUpValueError ? 'Value must be greater than 0' : ''}
                                        </div>
                                        <Select
                                            onChange={(val) => {
                                                setScheduleSmartFollowUpUnit(val);
                                            }}
                                            value={scheduleSmartFollowUpUnit}
                                            style={{ width: '120px' }}
                                        >
                                            <Select.Option value={EScheduleUnit.DAYS}>
                                                {EScheduleUnit.DAYS}
                                            </Select.Option>
                                            <Select.Option value={EScheduleUnit.WEEKS}>
                                                {EScheduleUnit.WEEKS}
                                            </Select.Option>
                                            <Select.Option value={EScheduleUnit.MONTHS}>
                                                {EScheduleUnit.MONTHS}
                                            </Select.Option>
                                        </Select>
                                    </div>
                                </div>
                                <div className={s.mScheduleItemContentDay}>
                                    <div className={s.mLabel}>Time:</div>
                                    <div className={s.mValue}>
                                        <TimePicker
                                            value={scheduleSmartFollowUpTime || dayjs(appointmentEventDetail?.startAt)}
                                            use12Hours
                                            minuteStep={15}
                                            format="h:mm a"
                                            onChange={(val) => {
                                                if (val) {
                                                    setScheduleSmartFollowUpTime(val);
                                                } else {
                                                    setScheduleSmartFollowUpTime(undefined);
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className={s.mValueTips}>
                                        Timezone:  {timezone || myTimezone?.value}
                                    </div>
                                </div>
                            </div> */}
                            {
                                showLinkToServiceSetting && (
                                    <div className={s.cancelNote2}>
                                        <div className={s.cancelNoteTitle2}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M8.25803 3.09858C9.02264 1.73928 10.9797 1.73928 11.7443 3.09858L17.3246 13.0191C18.0746 14.3523 17.1111 15.9996 15.5815 15.9996H4.42088C2.89123 15.9996 1.9278 14.3523 2.67773 13.0191L8.25803 3.09858ZM11.0011 12.9998C11.0011 13.552 10.5534 13.9998 10.0011 13.9998C9.44881 13.9998 9.0011 13.552 9.0011 12.9998C9.0011 12.4475 9.44881 11.9998 10.0011 11.9998C10.5534 11.9998 11.0011 12.4475 11.0011 12.9998ZM10.0011 4.99976C9.44881 4.99976 9.0011 5.44747 9.0011 5.99976V8.99976C9.0011 9.55204 9.44881 9.99976 10.0011 9.99976C10.5534 9.99976 11.0011 9.55204 11.0011 8.99976V5.99976C11.0011 5.44747 10.5534 4.99976 10.0011 4.99976Z" fill="#FBBF24" />
                                            </svg>
                                            Add a follow-up service to continue
                                        </div>
                                        <div className={s.cancelNoteContent2}>
                                            You haven’t added a follow-up visit type for this specialty yet. To continue, please <span onClick={handleOpenServiceSetting} className={s.linkToService}>go to your service settings</span> and set it up first.
                                        </div>
                                    </div>
                                )
                            }
                            {
                                canFollowUp && (
                                    <>
                                        <div className={s.mScheduleItemSumTitle}>Appointment</div>
                                        <div className={s.mScheduleItemSum}>
                                            <div className={s.sumDay}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                    <path d="M8 7.1748V3.1748M16 7.1748V3.1748M7 11.1748H17M5 21.1748H19C20.1046 21.1748 21 20.2794 21 19.1748V7.1748C21 6.07024 20.1046 5.1748 19 5.1748H5C3.89543 5.1748 3 6.07024 3 7.1748V19.1748C3 20.2794 3.89543 21.1748 5 21.1748Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                {scheduleSmartFollowUpDateLabel}
                                                <span
                                                    onClick={() => {
                                                        setShowTimeSelectModal(true);
                                                    }}
                                                    className={s.changeTime}
                                                >
                                                    Change time
                                                </span>
                                            </div>
                                            <div className={s.sumTime}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                    <path d="M12 8.1748V12.1748L15 15.1748M21 12.1748C21 17.1454 16.9706 21.1748 12 21.1748C7.02944 21.1748 3 17.1454 3 12.1748C3 7.20424 7.02944 3.1748 12 3.1748C16.9706 3.1748 21 7.20424 21 12.1748Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                {scheduleSmartFollowUpTimeLabel}
                                            </div>
                                            {
                                                appointmentEventDetail?.contactType === EContactTypeV2.VIDEO && appointmentEventDetail?.externalVideoLink && (
                                                    <>
                                                        <div className={s.sumTime}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M17.6569 16.6569C16.7202 17.5935 14.7616 19.5521 13.4138 20.8999C12.6327 21.681 11.3677 21.6814 10.5866 20.9003C9.26234 19.576 7.34159 17.6553 6.34315 16.6569C3.21895 13.5327 3.21895 8.46734 6.34315 5.34315C9.46734 2.21895 14.5327 2.21895 17.6569 5.34315C20.781 8.46734 20.781 13.5327 17.6569 16.6569Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                            Video Call
                                                        </div>
                                                        <a href={appointmentEventDetail?.externalVideoLink} className={s.sumVideoLink}>{appointmentEventDetail?.externalVideoLink}</a>
                                                    </>
                                                )
                                            }
                                            {
                                                appointmentEventDetail?.contactType === EContactTypeV2.IN_PERSON && appointmentEventDetail?.location && (
                                                    <>
                                                        <div className={s.sumTime}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M17.6569 16.6569C16.7202 17.5935 14.7616 19.5521 13.4138 20.8999C12.6327 21.681 11.3677 21.6814 10.5866 20.9003C9.26234 19.576 7.34159 17.6553 6.34315 16.6569C3.21895 13.5327 3.21895 8.46734 6.34315 5.34315C9.46734 2.21895 14.5327 2.21895 17.6569 5.34315C20.781 8.46734 20.781 13.5327 17.6569 16.6569Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                            In-person visit
                                                        </div>
                                                        <div className={s.sumValue}>{appointmentEventDetail?.location}</div>
                                                    </>
                                                )
                                            }
                                            {
                                                appointmentEventDetail?.contactType === EContactTypeV2.TELEPHONE && appointmentEventDetail?.telephone && (
                                                    <>
                                                        <div className={s.sumTime}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M17.6569 16.6569C16.7202 17.5935 14.7616 19.5521 13.4138 20.8999C12.6327 21.681 11.3677 21.6814 10.5866 20.9003C9.26234 19.576 7.34159 17.6553 6.34315 16.6569C3.21895 13.5327 3.21895 8.46734 6.34315 5.34315C9.46734 2.21895 14.5327 2.21895 17.6569 5.34315C20.781 8.46734 20.781 13.5327 17.6569 16.6569Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                            Telephone visit
                                                        </div>
                                                        <div className={s.sumValue}>{appointmentEventDetail?.telephone}</div>
                                                    </>
                                                )
                                            }
                                            <div className={s.sumTime}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M21 13.2554C18.2207 14.3805 15.1827 15 12 15C8.8173 15 5.7793 14.3805 3 13.2554M16 6V4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4V6M12 12H12.01M5 20H19C20.1046 20 21 19.1046 21 18V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                🔄 Established patient visit
                                            </div>
                                            {
                                                appointmentEventDetail?.serviceSpecialty && (
                                                    <div className={s.sumTime}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21L21 21M19 21H14M5 21L3 21M5 21H10M9 6.99998H10M9 11H10M14 6.99998H15M14 11H15M10 21V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V21M10 21H14" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                        {appointmentEventDetail?.serviceSpecialty}
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </>
                                )
                            }

                            <div className={s.msgToWrap}>
                                <div className={s.mtTitle}>Message to patient</div>
                                <div className={s.mtContent}>
                                    <div className={s.mtHeader}>
                                        Dear {targetClient?.firstName},
                                    </div>
                                    <div className={s.mtDes}>
                                        Following our recent <span style={{ color: '#000' }}>{appointmentEventDetail?.serviceType}</span> on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span>, your next follow-up appointment has been scheduled.
                                        <br />
                                        <br />
                                        If the new time doesn’t work for you, you can reschedule or message me directly in your patient portal.
                                    </div>
                                    <div className={s.mtCus}>
                                        <div className={s.mtCusTitle}>
                                            Customized message to patient <span style={{ color: '#8E8E8E' }}>(optional)</span>
                                        </div>
                                        <div className={s.mtCusValue}>
                                            <Input.TextArea
                                                onChange={(e) => {
                                                    setScheduleSmartFollowUpText(e.target.value);
                                                }}
                                                placeholder="Add customized message..."
                                                value={scheduleSmartFollowUpText}
                                                rows={4}
                                            />
                                        </div>
                                    </div>
                                    <div className={s.mtFooter}>
                                        <p>Looking forward to our visit,</p>
                                        <p className={s.mSign}>Email signature</p>
                                        <p>
                                            <Input
                                                value={emailSign}
                                                onChange={(e) => {
                                                    setEmailSign(e.target.value);
                                                }}
                                                placeholder={`${getProviderNameDisplay(getUser('data') as any)}${getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''}`}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            onClick={() => {
                                setSelectScheduleItemIndex(2);
                            }}
                            className={`${s.mScheduleItem} ${selectScheduleItemIndex === 2 ? s.mScheduleItemSelect : ''}`}
                        >
                            <div className={s.mScheduleItemTitle}>
                                <div className={s.mScheduleItemTitleLeft}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Send patient a reminder to schedule a follow-up
                                </div>
                                <div className={s.mScheduleItemTitleRight}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.9984 21.5999C17.3004 21.5999 21.5984 17.3018 21.5984 11.9999C21.5984 6.69797 17.3004 2.3999 11.9984 2.3999C6.6965 2.3999 2.39844 6.69797 2.39844 11.9999C2.39844 17.3018 6.6965 21.5999 11.9984 21.5999ZM16.447 10.4484C16.9156 9.9798 16.9156 9.22 16.447 8.75137C15.9783 8.28275 15.2185 8.28275 14.7499 8.75137L10.7984 12.7028L9.24696 11.1514C8.77833 10.6827 8.01854 10.6827 7.54991 11.1514C7.08128 11.62 7.08128 12.3798 7.54991 12.8484L9.94991 15.2484C10.4185 15.7171 11.1783 15.7171 11.647 15.2484L16.447 10.4484Z" fill="#00816B" />
                                    </svg>
                                </div>
                            </div>
                            <div className={s.mScheduleItemDes}>
                                A reminder will be sent to the patient in {dayjs(scheduleReminderTime).diff(dayjs(), 'days')} {scheduleReminderUnit}. You can update the time if needed.
                            </div>
                            {/* <div className={s.mScheduleItemContent}>
                                <div className={s.mScheduleItemContentDay}>
                                    <div className={s.mLabel}>Date:</div>
                                    <div className={s.mValue}>
                                        <InputNumber
                                            step={1}
                                            type="number"
                                            value={scheduleReminderValue}
                                            maxLength={3}
                                            className={s.input}
                                            status={scheduleReminderValueError ? 'error' : undefined}
                                            onChange={(e) => {
                                                if (!e && e !== 0) {
                                                    setScheduleReminderValue(undefined);
                                                    return;
                                                }
                                                const text = (`${e}`).replace(/\D/g, '');
                                                if (text) {
                                                    const valNum = parseInt(text);
                                                    if (Number.isNaN(valNum)) {
                                                        setScheduleReminderValue(undefined);
                                                        return;
                                                    }
                                                    setScheduleReminderValue(valNum);
                                                } else {
                                                    setScheduleReminderValue(undefined);
                                                }
                                            }}
                                        />
                                        <div className={s.inputError}>
                                            {scheduleReminderValueError ? 'Value must be greater than 0' : ''}
                                        </div>
                                        <Select
                                            style={{ width: '120px' }}
                                            onChange={(val) => {
                                                setScheduleReminderUnit(val);
                                            }}
                                            value={scheduleReminderUnit}
                                        >
                                            <Select.Option value={EScheduleUnit.DAYS}>
                                                {EScheduleUnit.DAYS}
                                            </Select.Option>
                                            <Select.Option value={EScheduleUnit.WEEKS}>
                                                {EScheduleUnit.WEEKS}
                                            </Select.Option>
                                            <Select.Option value={EScheduleUnit.MONTHS}>
                                                {EScheduleUnit.MONTHS}
                                            </Select.Option>
                                        </Select>
                                    </div>
                                </div>
                                <div className={s.mScheduleItemContentDay}>
                                    <div className={s.mLabel}>Time:</div>
                                    <div className={s.mValue}>
                                        <TimePicker
                                            value={scheduleReminderTime || dayjs(appointmentEventDetail?.startAt)}
                                            minuteStep={15}
                                            use12Hours
                                            format="h:mm a"
                                            onChange={(val) => {
                                                if (val) {
                                                    setScheduleReminderTime(val);
                                                } else {
                                                    setScheduleReminderTime(undefined);
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className={s.mValueTips}>
                                        Timezone:  {timezone || myTimezone?.value}
                                    </div>
                                </div>
                            </div> */}
                            {
                                showLinkToServiceSetting && (
                                    <div className={s.cancelNote2}>
                                        <div className={s.cancelNoteTitle2}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M8.25803 3.09858C9.02264 1.73928 10.9797 1.73928 11.7443 3.09858L17.3246 13.0191C18.0746 14.3523 17.1111 15.9996 15.5815 15.9996H4.42088C2.89123 15.9996 1.9278 14.3523 2.67773 13.0191L8.25803 3.09858ZM11.0011 12.9998C11.0011 13.552 10.5534 13.9998 10.0011 13.9998C9.44881 13.9998 9.0011 13.552 9.0011 12.9998C9.0011 12.4475 9.44881 11.9998 10.0011 11.9998C10.5534 11.9998 11.0011 12.4475 11.0011 12.9998ZM10.0011 4.99976C9.44881 4.99976 9.0011 5.44747 9.0011 5.99976V8.99976C9.0011 9.55204 9.44881 9.99976 10.0011 9.99976C10.5534 9.99976 11.0011 9.55204 11.0011 8.99976V5.99976C11.0011 5.44747 10.5534 4.99976 10.0011 4.99976Z" fill="#FBBF24" />
                                            </svg>
                                            Add a follow-up service to continue
                                        </div>
                                        <div className={s.cancelNoteContent2}>
                                            You haven’t added a follow-up visit type for this specialty yet. To continue, please <span onClick={handleOpenServiceSetting} className={s.linkToService}>go to your service settings</span> and set it up first.
                                        </div>
                                    </div>
                                )
                            }
                            {
                                canFollowUp &&
                                <>
                                    <div className={s.mScheduleItemSumTitle}>Recommend time</div>
                                    <div className={s.mScheduleItemSum}>
                                        <div className={s.sumDay}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                <path d="M8 7.1748V3.1748M16 7.1748V3.1748M7 11.1748H17M5 21.1748H19C20.1046 21.1748 21 20.2794 21 19.1748V7.1748C21 6.07024 20.1046 5.1748 19 5.1748H5C3.89543 5.1748 3 6.07024 3 7.1748V19.1748C3 20.2794 3.89543 21.1748 5 21.1748Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            {scheduleReminderDateLabel}
                                            <span
                                                onClick={() => {
                                                    setShowTimeSelectModal(true);
                                                }}
                                                className={s.changeTime}
                                            >
                                                Change time
                                            </span>
                                        </div>
                                        <div className={s.sumTime}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                <path d="M12 8.1748V12.1748L15 15.1748M21 12.1748C21 17.1454 16.9706 21.1748 12 21.1748C7.02944 21.1748 3 17.1454 3 12.1748C3 7.20424 7.02944 3.1748 12 3.1748C16.9706 3.1748 21 7.20424 21 12.1748Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            {scheduleReminderTimeLabel}
                                            {timeZoneLabel ? ` (${timeZoneLabel})` : ''}
                                        </div>
                                    </div>
                                </>
                            }
                            <div className={s.msgToWrap}>
                                <div className={s.mtTitle}>Message to patient</div>
                                <div className={s.mtContent}>
                                    <div className={s.mtHeader}>
                                        Dear {targetClient?.firstName},
                                    </div>
                                    <div className={s.mtDes}>
                                        Just a quick note following our recent visit <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span>.
                                    </div>
                                    <div className={s.mtCus}>
                                        <div className={s.mtCusTitle}>
                                            Customized message to patient <span style={{ color: '#8E8E8E' }}>(optional)</span>
                                        </div>
                                        <div className={s.mtCusValue}>
                                            <Input.TextArea
                                                onChange={(e) => {
                                                    setScheduleReminderText(e.target.value);
                                                }}
                                                ref={scheduleReminderAreaRef}
                                                value={scheduleReminderText}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Tab' && !scheduleReminderText) {
                                                        e.preventDefault(); // 防止默认的Tab行为（切换焦点）
                                                        setScheduleReminderText('To support your ongoing care, I recommend scheduling your next visit. You can choose a time that works best for you.');
                                                    }
                                                }}
                                                rows={4}
                                            />

                                            {
                                                !scheduleReminderText &&
                                                <div
                                                    onClick={() => {
                                                        scheduleReminderAreaRef?.current?.focus();
                                                    }}
                                                    className={s.placeHolder}
                                                >
                                                    To support your ongoing care, I recommend scheduling your next visit. You can choose a time that works best for you.
                                                    <span className={s.placeHolderText}>Press “Tab” to use the text</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className={s.mtFooter}>
                                        <p>Looking forward to our visit,</p>
                                        <p className={s.mSign}>Email signature</p>
                                        <p>
                                            <Input
                                                value={emailSign}
                                                onChange={(e) => {
                                                    setEmailSign(e.target.value);
                                                }}
                                                placeholder={`${getProviderNameDisplay(getUser('data') as any)}${getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''}`}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {
                showAddClient && (
                    <AddAndUpdateProspects
                        wrapClassName={s.addClientWrap}
                        show
                        onSuccess={(id) => {
                            setPendingClientId(id);
                            run();
                            setShowAddClient(false);
                        }}
                        onCannel={() => {
                            setShowAddClient(false);
                        }}
                    />
                )
            }
            <Modal
                open={showTimeSelectModal}
                onCancel={() => {
                    setScheduleReminderTime(defaultNextFollowUpTime);
                    setScheduleSmartFollowUpTime(defaultNextFollowUpTime);
                    setShowTimeSelectModal(false);
                }}
                className={s.modalWrap}
                wrapClassName="practice"
                width={660}
                onOk={() => {
                    setShowTimeSelectModal(false);
                }}
            >
                <div className={s.modalWrap}>
                    <div className={`${s.timePicker} ${s.timePickerShow}`}>
                        <div className={s.modalTitle}>
                            <h3>Select date and time</h3>
                            <div className={s.subTitle}>{timeZoneLabel ? `Timezone: ${timeZoneLabel}` : ''}</div>
                        </div>
                        {
                            selectScheduleItemIndex === 1 && (
                                <div className={s.modalService}>
                                    <span style={{ color: '#00816B' }}>Service:</span> {followUpServiceLabel}
                                </div>
                            )
                        }
                        <div className={s.timePickerIn}>
                            <TimePicker
                                idSub="modal"
                                loading={loadingTimeSlot}
                                onChange={(time: number) => {
                                    if (selectScheduleItemIndex === 1) {
                                        setScheduleSmartFollowUpTime(time);
                                    } else {
                                        setScheduleReminderTime(time);
                                    }
                                }}
                                timeSlotList={timeSlotList}
                                timezone={timezone}
                                defaultValue={defaultNextFollowUpTime}
                                extraTop={selectScheduleItemIndex === 1 ? 50 : 0}
                            />
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showConfirmProviderCancelModal}
                title="Cancel appointment"
                width={660}
                okText="Delete"
                onCancel={() => {
                    setCancelReason(undefined);
                    setCancelReasonSub(undefined);
                    setCancelReasonOther(undefined);
                    setShowConfirmProviderCancelModal(false);
                }}
                className={commonS.modalFixHeightWrap}
                style={{ opacity: showRescheduleConfirmModal ? 0 : 1 }}
                footer={(
                    <div className={s.cancelBtn}>
                        <Button
                            disabled={!canCancelAppointment}
                            onClick={() => {
                                handleConfirmProviderCancel();
                            }}
                            loading={updatingScheduleType}
                            className={s.deleteBtn}
                        >
                            Cancel appointment
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                //todo
                                setShowReschedulePickTimeModal(true);
                            }}
                            className={s.deleteBtn}
                            disabled={!cancelReason}
                        >
                            Reschedule appointment
                        </Button>
                    </div>
                )}
            >
                <div className={s.cancelWrapOut}>
                    <div className={s.cancelWrap}>
                        <div className={s.cancelTitle}>
                            Please select a reason for canceling this appointment. You could also include a brief custom message for the patient.
                        </div>
                        <div className={s.cancelReason}>
                            <Radio.Group
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 8,
                                }}
                                onChange={(e) => {
                                    setCancelReason(e.target.value);
                                }}
                                value={cancelReason}
                                options={optionProviderCancelReason}
                            />
                        </div>
                        {
                            cancelReason === EProvicerCancelReasonLabel.SCHEDULE_CONFLICTS &&
                            <div className={s.cancelNote}>
                                <div className={s.cancelNoteTitle}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M11.5664 3C11.5664 2.44772 11.1187 2 10.5664 2C10.0141 2 9.56641 2.44772 9.56641 3V4C9.56641 4.55228 10.0141 5 10.5664 5C11.1187 5 11.5664 4.55228 11.5664 4V3Z" fill="#60A5FA" />
                                        <path d="M16.2232 5.75731C16.6137 5.36678 16.6137 4.73362 16.2232 4.34309C15.8327 3.95257 15.1995 3.95257 14.809 4.34309L14.1019 5.0502C13.7114 5.44072 13.7114 6.07389 14.1019 6.46441C14.4924 6.85494 15.1256 6.85494 15.5161 6.46441L16.2232 5.75731Z" fill="#60A5FA" />
                                        <path d="M18.5664 10C18.5664 10.5523 18.1187 11 17.5664 11H16.5664C16.0141 11 15.5664 10.5523 15.5664 10C15.5664 9.44771 16.0141 9 16.5664 9H17.5664C18.1187 9 18.5664 9.44771 18.5664 10Z" fill="#60A5FA" />
                                        <path d="M5.61659 6.46443C6.00712 6.85496 6.64028 6.85496 7.03081 6.46443C7.42133 6.07391 7.42133 5.44074 7.03081 5.05022L6.3237 4.34311C5.93318 3.95259 5.30001 3.95259 4.90949 4.34311C4.51896 4.73363 4.51896 5.3668 4.90949 5.75732L5.61659 6.46443Z" fill="#60A5FA" />
                                        <path d="M5.56641 10C5.56641 10.5523 5.11869 11 4.56641 11H3.56641C3.01412 11 2.56641 10.5523 2.56641 10C2.56641 9.44771 3.01412 9 3.56641 9H4.56641C5.11869 9 5.56641 9.44771 5.56641 10Z" fill="#60A5FA" />
                                        <path d="M8.56641 16V15H12.5664V16C12.5664 17.1046 11.671 18 10.5664 18C9.46184 18 8.56641 17.1046 8.56641 16Z" fill="#60A5FA" />
                                        <path d="M12.5673 14C12.5819 13.6597 12.774 13.3537 13.0432 13.1411C13.971 12.4086 14.5664 11.2738 14.5664 10C14.5664 7.79086 12.7755 6 10.5664 6C8.35727 6 6.56641 7.79086 6.56641 10C6.56641 11.2738 7.16185 12.4086 8.08959 13.1411C8.35881 13.3537 8.55092 13.6597 8.56551 14H12.5673Z" fill="#60A5FA" />
                                    </svg>
                                    Rescheduling recommended
                                </div>
                                <div className={s.cancelNoteContent}>
                                    To help patients stay engaged and on track with care, we recommend rescheduling instead of canceling whenever possible.
                                </div>
                            </div>
                        }
                        {
                            cancelReason === EProvicerCancelReasonLabel.MISMATCH_WITH_SCOPE &&
                            <div className={s.cancelNote2}>
                                <div className={s.cancelNoteTitle2}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8.25803 3.09858C9.02264 1.73928 10.9797 1.73928 11.7443 3.09858L17.3246 13.0191C18.0746 14.3523 17.1111 15.9996 15.5815 15.9996H4.42088C2.89123 15.9996 1.9278 14.3523 2.67773 13.0191L8.25803 3.09858ZM11.0011 12.9998C11.0011 13.552 10.5534 13.9998 10.0011 13.9998C9.44881 13.9998 9.0011 13.552 9.0011 12.9998C9.0011 12.4475 9.44881 11.9998 10.0011 11.9998C10.5534 11.9998 11.0011 12.4475 11.0011 12.9998ZM10.0011 4.99976C9.44881 4.99976 9.0011 5.44747 9.0011 5.99976V8.99976C9.0011 9.55204 9.44881 9.99976 10.0011 9.99976C10.5534 9.99976 11.0011 9.55204 11.0011 8.99976V5.99976C11.0011 5.44747 10.5534 4.99976 10.0011 4.99976Z" fill="#FBBF24" />
                                    </svg>
                                    Important notice
                                </div>
                                <div className={s.cancelNoteContent2}>
                                    If you cancel the appointment, the patient may contact Klarity to seek alternative care. Rescheduling allows you to continue care with this patient — canceling may reduce the likelihood of them returning.
                                </div>
                            </div>
                        }
                        {
                            cancelReason === EProvicerCancelReasonLabel.INSURANCE_MISMATCH &&
                            <div className={s.cancelNote2}>
                                <div className={s.cancelNoteTitle2}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8.25803 3.09858C9.02264 1.73928 10.9797 1.73928 11.7443 3.09858L17.3246 13.0191C18.0746 14.3523 17.1111 15.9996 15.5815 15.9996H4.42088C2.89123 15.9996 1.9278 14.3523 2.67773 13.0191L8.25803 3.09858ZM11.0011 12.9998C11.0011 13.552 10.5534 13.9998 10.0011 13.9998C9.44881 13.9998 9.0011 13.552 9.0011 12.9998C9.0011 12.4475 9.44881 11.9998 10.0011 11.9998C10.5534 11.9998 11.0011 12.4475 11.0011 12.9998ZM10.0011 4.99976C9.44881 4.99976 9.0011 5.44747 9.0011 5.99976V8.99976C9.0011 9.55204 9.44881 9.99976 10.0011 9.99976C10.5534 9.99976 11.0011 9.55204 11.0011 8.99976V5.99976C11.0011 5.44747 10.5534 4.99976 10.0011 4.99976Z" fill="#FBBF24" />
                                    </svg>
                                    Important notice
                                </div>
                                <div className={s.cancelNoteContent2}>
                                    If you cancel the appointment, the patient may contact Klarity to seek alternative care. Rescheduling allows you to continue care with this patient — canceling may reduce the likelihood of them returning.
                                </div>
                            </div>
                        }
                        {
                            cancelReason === EProvicerCancelReasonLabel.OUTSTANDING_PAYMENTS &&
                            <div className={s.cancelNote}>
                                <div className={s.cancelNoteTitle}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M11.5664 3C11.5664 2.44772 11.1187 2 10.5664 2C10.0141 2 9.56641 2.44772 9.56641 3V4C9.56641 4.55228 10.0141 5 10.5664 5C11.1187 5 11.5664 4.55228 11.5664 4V3Z" fill="#60A5FA" />
                                        <path d="M16.2232 5.75731C16.6137 5.36678 16.6137 4.73362 16.2232 4.34309C15.8327 3.95257 15.1995 3.95257 14.809 4.34309L14.1019 5.0502C13.7114 5.44072 13.7114 6.07389 14.1019 6.46441C14.4924 6.85494 15.1256 6.85494 15.5161 6.46441L16.2232 5.75731Z" fill="#60A5FA" />
                                        <path d="M18.5664 10C18.5664 10.5523 18.1187 11 17.5664 11H16.5664C16.0141 11 15.5664 10.5523 15.5664 10C15.5664 9.44771 16.0141 9 16.5664 9H17.5664C18.1187 9 18.5664 9.44771 18.5664 10Z" fill="#60A5FA" />
                                        <path d="M5.61659 6.46443C6.00712 6.85496 6.64028 6.85496 7.03081 6.46443C7.42133 6.07391 7.42133 5.44074 7.03081 5.05022L6.3237 4.34311C5.93318 3.95259 5.30001 3.95259 4.90949 4.34311C4.51896 4.73363 4.51896 5.3668 4.90949 5.75732L5.61659 6.46443Z" fill="#60A5FA" />
                                        <path d="M5.56641 10C5.56641 10.5523 5.11869 11 4.56641 11H3.56641C3.01412 11 2.56641 10.5523 2.56641 10C2.56641 9.44771 3.01412 9 3.56641 9H4.56641C5.11869 9 5.56641 9.44771 5.56641 10Z" fill="#60A5FA" />
                                        <path d="M8.56641 16V15H12.5664V16C12.5664 17.1046 11.671 18 10.5664 18C9.46184 18 8.56641 17.1046 8.56641 16Z" fill="#60A5FA" />
                                        <path d="M12.5673 14C12.5819 13.6597 12.774 13.3537 13.0432 13.1411C13.971 12.4086 14.5664 11.2738 14.5664 10C14.5664 7.79086 12.7755 6 10.5664 6C8.35727 6 6.56641 7.79086 6.56641 10C6.56641 11.2738 7.16185 12.4086 8.08959 13.1411C8.35881 13.3537 8.55092 13.6597 8.56551 14H12.5673Z" fill="#60A5FA" />
                                    </svg>
                                    Rescheduling recommended
                                </div>
                                <div className={s.cancelNoteContent}>
                                    Patients may need more time to settle outstanding payments. We recommend rescheduling rather than canceling.
                                </div>
                            </div>
                        }
                        {
                            cancelReason === EProvicerCancelReasonLabel.INCOMPLETE_PATIENT_INFORMATION &&
                            <div className={s.cancelNote}>
                                <div className={s.cancelNoteTitle}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M11.5664 3C11.5664 2.44772 11.1187 2 10.5664 2C10.0141 2 9.56641 2.44772 9.56641 3V4C9.56641 4.55228 10.0141 5 10.5664 5C11.1187 5 11.5664 4.55228 11.5664 4V3Z" fill="#60A5FA" />
                                        <path d="M16.2232 5.75731C16.6137 5.36678 16.6137 4.73362 16.2232 4.34309C15.8327 3.95257 15.1995 3.95257 14.809 4.34309L14.1019 5.0502C13.7114 5.44072 13.7114 6.07389 14.1019 6.46441C14.4924 6.85494 15.1256 6.85494 15.5161 6.46441L16.2232 5.75731Z" fill="#60A5FA" />
                                        <path d="M18.5664 10C18.5664 10.5523 18.1187 11 17.5664 11H16.5664C16.0141 11 15.5664 10.5523 15.5664 10C15.5664 9.44771 16.0141 9 16.5664 9H17.5664C18.1187 9 18.5664 9.44771 18.5664 10Z" fill="#60A5FA" />
                                        <path d="M5.61659 6.46443C6.00712 6.85496 6.64028 6.85496 7.03081 6.46443C7.42133 6.07391 7.42133 5.44074 7.03081 5.05022L6.3237 4.34311C5.93318 3.95259 5.30001 3.95259 4.90949 4.34311C4.51896 4.73363 4.51896 5.3668 4.90949 5.75732L5.61659 6.46443Z" fill="#60A5FA" />
                                        <path d="M5.56641 10C5.56641 10.5523 5.11869 11 4.56641 11H3.56641C3.01412 11 2.56641 10.5523 2.56641 10C2.56641 9.44771 3.01412 9 3.56641 9H4.56641C5.11869 9 5.56641 9.44771 5.56641 10Z" fill="#60A5FA" />
                                        <path d="M8.56641 16V15H12.5664V16C12.5664 17.1046 11.671 18 10.5664 18C9.46184 18 8.56641 17.1046 8.56641 16Z" fill="#60A5FA" />
                                        <path d="M12.5673 14C12.5819 13.6597 12.774 13.3537 13.0432 13.1411C13.971 12.4086 14.5664 11.2738 14.5664 10C14.5664 7.79086 12.7755 6 10.5664 6C8.35727 6 6.56641 7.79086 6.56641 10C6.56641 11.2738 7.16185 12.4086 8.08959 13.1411C8.35881 13.3537 8.55092 13.6597 8.56551 14H12.5673Z" fill="#60A5FA" />
                                    </svg>
                                    Rescheduling recommended
                                </div>
                                <div className={s.cancelNoteContent}>
                                    Patients may need more time to complete required forms. We recommend rescheduling rather than canceling.
                                </div>
                            </div>
                        }
                        {
                            cancelReason === EProvicerCancelReasonLabel.OTHER_REASONS &&
                            <div className={s.otherReason}>
                                <TextArea
                                    onChange={(e) => {
                                        setCancelReasonOther(e.target.value);
                                    }}
                                    className={s.otherInput}
                                    value={cancelReasonOther}
                                    rows={4}
                                    maxLength={2000}
                                    placeholder="Specify your reason for canceling this appointment..."
                                />
                            </div>
                        }
                        <div className={s.msgToWrap}>
                            <div className={s.mtTitle}>Message to patient</div>
                            <div className={s.mtContent}>
                                <div className={s.mtHeader}>
                                    Dear {targetClient?.firstName},
                                </div>
                                {
                                    (!cancelReason || cancelReason === EProvicerCancelReasonLabel.SCHEDULE_CONFLICTS || cancelReason === EProvicerCancelReasonLabel.OTHER_REASONS) && (
                                        <div className={s.mtDes}>
                                            I wanted to let you know that your {currentServiceType} scheduled on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span>  has been canceled. I apologize for any inconvenience this may cause.
                                        </div>
                                    )
                                }
                                {
                                    cancelReason === EProvicerCancelReasonLabel.MISMATCH_WITH_SCOPE && (
                                        <div className={s.mtDes}>
                                            I wanted to let you know that your {currentServiceType} scheduled on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span>  has been canceled. Based on the information you provided, it looks like your visit reason doesn't align with the scope of care I’m able to offer.
                                        </div>
                                    )
                                }
                                {
                                    cancelReason === EProvicerCancelReasonLabel.INSURANCE_MISMATCH && (
                                        <div className={s.mtDes}>
                                            I wanted to let you know that your {currentServiceType} scheduled on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span>  has been canceled. Based on the information you provided, it looks like your insurance isn’t one I’m currently able to accept.
                                        </div>
                                    )
                                }
                                {
                                    (cancelReason === EProvicerCancelReasonLabel.OUTSTANDING_PAYMENTS) && (
                                        <div className={s.mtDes}>
                                            I wanted to let you know that your {currentServiceType} scheduled on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span> has been canceled due to an outstanding payment.
                                            <br />
                                            <br />
                                            If you have any questions or need help resolving this, feel free to contact me directly.
                                        </div>
                                    )
                                }
                                {
                                    (cancelReason === EProvicerCancelReasonLabel.INCOMPLETE_PATIENT_INFORMATION) && (
                                        <div className={s.mtDes}>
                                            I wanted to let you know that your {currentServiceType} scheduled on <span style={{ color: '#000' }}>{appointmentDate?.format('MMM D, YYYY')} at {dayjs(appointmentEventDetail?.startAt!)?.format('hh:mm A')}</span> has been canceled due to incomplete paperwork.
                                            <br />
                                            <br />
                                            Once you've completed the necessary paperwork, feel free to reschedule at a time that works best for you.
                                        </div>
                                    )
                                }

                                <div className={s.mtCus}>
                                    <div className={s.mtCusTitle}>
                                        Customized message to patient <span style={{ color: '#8E8E8E' }}>(optional)</span>
                                    </div>
                                    <div className={s.mtCusValue}>
                                        <Input.TextArea
                                            onChange={(e) => {
                                                setCustomizeText(e.target.value);
                                            }}
                                            ref={textAreaRef}
                                            value={customizeText}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Tab' && !customizeText) {
                                                    e.preventDefault(); // 防止默认的Tab行为（切换焦点）
                                                    setCustomizeText('Please reach out to me so we can find a new time that works for you.');
                                                }
                                            }}
                                            rows={4}
                                        />
                                        {
                                            !customizeText &&
                                            <div
                                                onClick={() => {
                                                    textAreaRef?.current?.focus();
                                                }}
                                                className={s.placeHolder}
                                            >
                                                Please reach out to me so we can find a new time that works for you.
                                                <span className={s.placeHolderText}>Press “Tab” to use the text</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className={s.mtFooter}>
                                    <p>Best regards,</p>
                                    <p>
                                        <Input
                                            value={emailSign}
                                            onChange={(e) => {
                                                setEmailSign(e.target.value);
                                            }}
                                            placeholder={`${getProviderNameDisplay(getUser('data') as any)}${getUser('data')?.credential ? `, ${getUser('data')?.credential}` : ''}`}
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showReschedulePickTimeModal}
                onCancel={() => {
                    setShowReschedulePickTimeModal(false);
                }}
                className={s.modalWrap}
                wrapClassName="practice"
                width={660}
                onOk={() => {
                    setShowReschedulePickTimeModal(false);
                    setShowRescheduleConfirmModal(true);
                }}
                okText="Schedule"
            >
                <div className={s.modalWrap}>
                    <div className={`${s.timePicker} ${s.timePickerShow}`}>
                        <div className={s.modalTitle}>
                            <h3>Select date and time</h3>
                            <div className={s.subTitle}>{timeZoneLabel ? `Timezone: ${timeZoneLabel}` : ''}</div>
                        </div>
                        <div
                            onClick={() => {
                                setShowReschedulePickTimeModal(false);
                            }}
                            className={s.modalBack}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M6.66667 12.6654L2 7.9987M2 7.9987L6.66667 3.33203M2 7.9987L14 7.9987" stroke="#00816B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Back
                        </div>
                        <div className={s.modalService}>
                            <span style={{ color: '#00816B' }}>Service:</span> {rescheduleServiceLabel}
                        </div>
                        <div className={s.timePickerIn}>
                            <TimePicker
                                idSub="modal"
                                loading={loadingTimeSlot}
                                onChange={(time: number) => {
                                    setRescheduleTime(time);
                                }}
                                timeSlotList={timeSlotList}
                                timezone={timezone}
                                defaultValue={defaultRescheduleTime}
                                extraTop={100}
                            />
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showRescheduleConfirmModal}
                onCancel={() => {
                    setShowRescheduleConfirmModal(false);
                }}
                wrapClassName="practice"
                width={660}
                onOk={() => {
                    //update time
                    handleRescheduleConfirm();
                }}
                okText="Confirm"
                okButtonProps={{
                    loading: rescheduling,
                }}
            >
                <div className={s.modalWrap}>
                    <div className={`${s.timePicker} ${s.timePickerShow}`}>
                        <div className={s.modalTitle}>
                            <h3>Confirm appointment</h3>
                        </div>
                        <div
                            onClick={() => {
                                setShowRescheduleConfirmModal(false);
                                setShowReschedulePickTimeModal(true);
                            }}
                            className={s.modalBack}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M6.66667 12.6654L2 7.9987M2 7.9987L6.66667 3.33203M2 7.9987L14 7.9987" stroke="#00816B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Back
                        </div>
                        <div className={s.modalDes}>
                            You have scheduled a new appointment for patient {targetClient?.firstName} {targetClient?.lastName}. Please review and confirm the appointment details below:
                        </div>
                        <div className={s.modalUpdate}>
                            <div className={s.muItem}>
                                <div className={s.muItemLabel}>Service:</div>
                                <div className={s.muItemValue}>{rescheduleServiceLabel}</div>
                            </div>
                            <div className={s.muItem}>
                                <div className={s.muItemLabel}>Date:</div>
                                {/* Wednesday, March 5, 2025  */}
                                <div className={s.muItemValue}>{rescheduleDateLabel}</div>
                            </div>
                            <div className={s.muItem}>
                                <div className={s.muItemLabel}>Time:</div>
                                {/* 10:00 - 10:30am */}
                                <div className={s.muItemValue}>{rescheduleTimeLabel}</div>
                            </div>
                            <div className={s.muItem} />
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                open={showCannotChargeIn24HourModal}
                title={null}
                footer={null}
                onCancel={() => {
                    setShowCannotChargeIn24HourModal(false);
                }}
            >
                <div className={s.ccWrap}>
                    <div className={s.ccIcon}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M9.90652 3.71849C10.824 2.08733 13.1725 2.08733 14.0901 3.71849L20.7864 15.6231C21.6864 17.223 20.5302 19.1998 18.6947 19.1998H5.30193C3.46635 19.1998 2.31023 17.223 3.21015 15.6231L9.90652 3.71849ZM13.1982 15.5999C13.1982 16.2626 12.6609 16.7999 11.9982 16.7999C11.3355 16.7999 10.7982 16.2626 10.7982 15.5999C10.7982 14.9372 11.3355 14.3999 11.9982 14.3999C12.6609 14.3999 13.1982 14.9372 13.1982 15.5999ZM11.9982 5.9999C11.3355 5.9999 10.7982 6.53716 10.7982 7.1999V10.7999C10.7982 11.4626 11.3355 11.9999 11.9982 11.9999C12.6609 11.9999 13.1982 11.4626 13.1982 10.7999V7.1999C13.1982 6.53716 12.6609 5.9999 11.9982 5.9999Z" fill="#FBBF24" />
                        </svg>
                    </div>
                    <div className={s.ccInfo}>
                        <div className={s.ccTitle}>
                            You can’t charge a late cancellation fee
                        </div>
                        <div className={s.ccDes}>
                            {targetClient?.firstName} {targetClient?.lastName} canceled the appointment within the platform’s allowed cancellation window (24 hours). According to Klarity Health’s policy, you’re not allowed to apply a fee in this case.
                        </div>
                    </div>
                </div>

            </Modal>
        </div>
    );
};

export default AddAndEditCalendarEvent;
